// Português (Brasil)
const pt = {
  "nav.home": "Início",
  "nav.browse": "Ver ofertas",
  "nav.nearExpiry": "Perto do vencimento",
  "nav.categories": "Categorias",
  "nav.businesses": "Negócios",
  "nav.favourites": "Favoritos",
  "nav.following": "Seguindo",
  "follows.title": "Seguindo",
  "follows.subtitle": "Todas as lojas e lugares que você segue, em um só lugar. Avisamos quando postarem algo novo.",
  "follows.businesses": "Lojas que você segue ({n})",
  "follows.places": "Lugares que você segue ({n})",
  "follows.followPlace": "Seguir este lugar",
  "follows.following": "Seguindo",
  "follows.nowFollowing": "Seguindo {name}",
  "follows.unfollowed": "Deixou de seguir {name}",
  "follows.placeNudge": "Avisaremos quando qualquer loja daqui publicar uma oferta.",
  "follows.signIn": "Entre para seguir lojas e lugares",
  "follows.createAccount": "Criar uma conta grátis",
  "follows.emptyTitle": "Você ainda não segue ninguém",
  "follows.emptyBody": "Siga uma loja ou um shopping e as novas ofertas chegam a você.",
  "nav.myDeals": "Minhas ofertas",
  "nav.lytemap": "LyteMap",
  "nav.postDeal": "Publicar oferta",
  "nav.analytics": "Análises",
  "nav.admin": "Admin",
  "nav.ourStory": "Nossa história",
  "nav.myAccount": "Minha conta",
  "nav.pricing": "Preços",

  "brand.tagline": "Economize mais. Desperdice menos.",

  "sidebar.businessLogin": "Entrar",
  "sidebar.signupFree": "Novo por aqui? Cadastre-se grátis",
  "sidebar.proActive": "Pro ativo",
  "sidebar.until": "Até {date}",
  "sidebar.growPro": "Cresça com o Pro",
  "sidebar.growProDesc": "Destaque, ofertas ilimitadas e análises completas.",
  "sidebar.goPremium": "Seja Premium",

  "topbar.searchPlaceholder": "Busque ofertas, negócios ou categorias...",
  "topbar.aiPlaceholder": "Pergunte à IA: jantar barato perto…",
  "topbar.askAi": "Pergunte à IA",
  "topbar.nearMe": "Perto de mim",
  "topbar.anywhere": "Em qualquer lugar",
  "topbar.country": "País",
  "topbar.city": "Cidade",
  "topbar.allCities": "Todas as cidades",
  "topbar.useMyLocation": "Usar minha localização",
  "topbar.privacyNote": "Usamos a localização do seu dispositivo, não seu endereço IP — fica privado e preciso mesmo com VPN.",
  "topbar.typePlace": "ou digite uma cidade ou local…",
  "topbar.clearEverywhere": "Limpar — mostrar ofertas em todo lugar",
  "topbar.notifications": "Notificações",
  "topbar.more": "Mais opções",
  "topbar.darkMode": "Modo escuro",
  "topbar.lightMode": "Modo claro",
  "topbar.recent": "{n} recentes",
  "topbar.noNotifs": "Nenhuma notificação ainda.",
  "topbar.viewAllDeals": "Ver todas as ofertas",
  "topbar.hello": "Olá, {name}",
  "topbar.login": "Entrar",
  "topbar.try": "Tente:",

  "footer.contact": "Contato",
  "footer.terms": "Termos de uso",
  "footer.privacy": "Política de privacidade",
  "footer.pricing": "Preços",
  "footer.refunds": "Política de reembolso",

  "home.todaysBest": "As melhores ofertas de hoje",
  "home.upToOff": "Até {n}% de desconto",
  "home.explore": "Explorar ofertas",
  "home.browseCategories": "Ver categorias",
  "home.eduHeroA": "Aprenda por",
  "home.eduHeroB": "menos.",
  "home.eduHeroSub": "Encontre aulas, cursos e reforço perto de você, a preços que valem a pena.",
  "home.liveDeals": "{n} ofertas ativas",
  "home.categoriesCount": "{n} categorias",
  "home.shopByCategory": "Compre por categoria",
  "home.viewAll": "Ver tudo",
  "home.featuredDeals": "⭐ Ofertas em destaque",
  "home.featuredNearYou": "⭐ Destaques",
  "home.featuredIn": "⭐ Destaques em {place}",
  "home.topDeals": "Melhores ofertas",
  "home.topDealsNear": "Melhores ofertas perto de {place}",
  "home.topDealsNearYou": "Melhores ofertas perto de você",
  "home.locPromptTitle": "Veja ofertas bem perto de você",
  "home.locPromptDesc": "Compartilhe sua localização e colocaremos as ofertas mais próximas — com distâncias — no topo da sua página.",
  "home.shareLocation": "Compartilhar localização",
  "home.locating": "Localizando…",

  "tourist.visitingTitle": "Visitando a região?",
  "tourist.visitingDesc": "Ative o Modo Turista para ver as melhores ofertas perto de você, na sua moeda, com rotas em um toque.",
  "tourist.imVisiting": "Estou visitando",

  "rail.yourLocation": "Sua localização",
  "rail.change": "Alterar",
  "rail.featuredDeal": "Oferta em destaque",
  "rail.viewDeal": "Ver oferta",
  "rail.nearExpiry": "Perto do vencimento",
  "rail.lastChance": "(Última chance!)",
  "rail.viewAll": "Ver tudo",
  "rail.noNearExpiry": "Nenhum item perto do vencimento agora.",
  "rail.getAlerts": "Receba alertas de ofertas",
  "rail.getAlertsDesc": "Seja o primeiro a saber sobre novas ofertas e promoções relâmpago!",
  "rail.enableAlerts": "Ativar alertas",

  "lang.label": "Idioma",

  "cat.All": "Tudo",
  "cat.Food": "Comida",
  "cat.Drinks": "Bebidas",
  "cat.Health": "Saúde",
  "cat.Events": "Eventos",
  "cat.Lodging": "Hospedagem",
  "cat.Services": "Serviços",
  "cat.Pets": "Pets",
  "cat.Beauty": "Beleza",
  "cat.Tech": "Tecnologia",
  "cat.Near Expiry": "Perto do vencimento",
  "cat.Upcoming": "Em breve",
  "cat.Automotive": "Automotivo",
  "cat.Fitness": "Fitness",
  "cat.Clothing": "Roupas",
  "cat.Plants": "Plantas",
  "cat.Education": "Educação",
  "cat.Farm & Livestock": "Fazenda e Pecuária",
  "cat.Other": "Outros",
  "cat.More": "Mais",
  "time.expired": "Expirada",
  "time.dLeft": "{d}d {h}h restantes",
  "time.hLeft": "{h}h {m}m restantes",
  "time.mLeft": "{m}m {s}s restantes",
  "card.save": "Economize {amount}",
  "card.review": "{n} avaliação",
  "card.reviews": "{n} avaliações",
  "map.dealsHere": "{n} ofertas aqui",
  "map.dealsAtSpot": "{n} ofertas neste ponto",
  "map.businessesHere": "{n} negócios",
  "map.endsSoon": "termina em breve",
  "map.viewDeal": "Ver oferta",
  "map.directions": "Ver rota",
  "map.branchOf": "1 de {n} endereços",
  "map.approx": "{amount} aprox.",
  "map.subtitleGps": "Ofertas perto de {place} — busque outro lugar na barra de cima para mover o mapa.",
  "map.subtitle": "Compartilhe sua localização para ver na hora ofertas perto de você, ou busque uma cidade / escolha um país na barra de cima.",
  "map.yourLocation": "sua localização",
  "map.jumpTo": "Ir para:",
  "map.autoDetected": "Mostrando ofertas em {country} — não está certo?",
  "map.change": "Alterar",
  "map.maybeLaterBrowse": "Talvez depois — explorar {place}",
  "map.allDeals": "todas as ofertas",
  "map.endingSoon": "Terminam em breve",
  "map.inView": "Na tela",
  "map.all": "Tudo",
  "map.inViewCount": "{n} de {m} na tela",
  "map.nearbyCount": "{n} de {m} por perto",
  "map.dealCount": "{n} ofertas",
  "map.dealCountNearby": "{n} ofertas por perto",
  "map.fitAll": "Ver todas as ofertas",
  "map.geoTitle": "Veja ofertas perto de você",
  "map.geoDesc": "Compartilhe sua localização e mostramos na hora as melhores ofertas ao seu redor no mapa.",
  "map.emptyFilter": "Nenhuma oferta combina com este filtro por aqui.",
  "map.emptyGps": "Ainda não há ofertas perto deste local — tente outro lugar ou explore por país.",
  "map.emptyCountry": "Ainda não há ofertas em {country}.",
  "map.emptyInView": "Nenhuma oferta nesta parte do mapa.",
  "map.zoomOut": "Diminua o zoom para ver as {n}",
  "map.myLocation": "Sua localização",
  "map.expandMap": "Ampliar mapa",
  "map.showList": "Ver ofertas",
  "map.openNow": "Aberto agora",
  "map.openBadge": "Aberto agora",
  "map.closedBadge": "Fechado agora",
  "map.heatmap": "Mapa de descontos",
  "map.heatLegend": "Os maiores descontos desta área",
  "map.shareView": "Compartilhar esta visualização",
  "map.shareTitle": "Ofertas na LytePress",
  "map.linkCopied": "Link copiado — compartilhe onde quiser",
  "map.sharedView": "Mostrando uma visualização compartilhada do mapa",
  "map.world": "Mundo",
  "map.shopsHere": "{n} lojas",
  "map.sharedAddress": "{n} lojas neste endereço",
  "spot.eyebrow": "Todas as ofertas neste endereço",
  "spot.fallbackTitle": "Este endereço",
  "spot.dealCount": "{n} ofertas",
  "spot.visitShop": "Ver loja",
  "spot.seeAll": "Ver tudo",
  "spot.backToMap": "Voltar ao LyteMap",
  "spot.gone": "Nenhuma oferta ativa neste endereço agora.",
  "spot.share": "Compartilhar estas ofertas",
  "spot.shareCopied": "Copiado — cole onde quiser",
  "spot.shareHead": "{name} — {shops} lojas, {deals} ofertas na LytePress agora:",
  "spot.shareMore": "…e mais {n}",
  "map.noDealsRegion": "Ainda não há ofertas nesta região.",
  "invite.cta": "Convidar um negócio",
  "invite.title": "Convide um negócio para a LytePress",
  "invite.subtitle": "Conhece uma loja com ofertas que valem a pena? Conte-nos e nós convidamos.",
  "invite.namePh": "Nome do negócio",
  "invite.cityPh": "Cidade",
  "invite.countryPh": "País",
  "invite.emailPh": "E-mail dele (opcional)",
  "invite.notePh": "Por que os compradores deveriam conhecer? (opcional)",
  "invite.submit": "Enviar convite",
  "invite.privacy": "Usamos esses dados apenas para convidar o negócio. Nenhuma conta é criada.",
  "invite.sentEmail": "Convite enviado por e-mail",
  "invite.logged": "Obrigado — anotado!",
  "invite.nudge": "Uma mensagem pessoal funciona melhor. Envie isto:",
  "invite.shareMsg": "Oi {name}! Publique suas ofertas na LytePress para que os compradores por perto te encontrem — começar é grátis: {url}",
  "invite.whatsapp": "Enviar no WhatsApp",
  "invite.copy": "Copiar mensagem",
  "invite.failed": "Não foi possível enviar o convite. Tente novamente.",
  "map.citiesIn": "Cidades em {country}:",
  "map.allOf": "Todo o {country}",
  "map.moreCountries": "+{n} países",
  "map.fewerCountries": "Mostrar menos",
  "map.countriesIn": "Países em {region}:",
  "reg.Caribbean": "Caribe",
  "reg.North America": "América do Norte",
  "reg.Central America": "América Central",
  "reg.South America": "América do Sul",
  "reg.Europe": "Europa",
  "reg.Middle East": "Oriente Médio",
  "reg.Africa": "África",
  "reg.Asia": "Ásia",
  "reg.Oceania": "Oceania",
  "reg.Other": "Outros",
  "pd.postTitle": "Publicar oferta",
  "pd.editTitle": "Editar oferta",
  "pd.dealTitle": "Título da oferta",
  "pd.dealTitlePh": "ex. Pizzas grandes 2 por 1",
  "pd.photos": "Fotos da oferta",
  "pd.photosHint": "(até 6 - os compradores podem deslizar)",
  "pd.cover": "Capa",
  "pd.category": "Categoria",
  "pd.currency": "Moeda",
  "pd.redeemHow": "Como esta oferta é resgatada?",
  "pd.inPerson": "Presencial",
  "pd.onlineOnly": "Somente online",
  "pd.onlineNote": "Sem pino no mapa - compradores do mundo todo vão ver",
  "pd.promoLabel": "Código promocional usado no checkout",
  "pd.promoHint": "Fica oculto até o comprador pegar a oferta e depois aparece com um botão de copiar. Confirme que funciona no seu site.",
  "pd.whichLocations": "A quais endereços esta oferta se aplica?",
  "pd.pinLabel": "Marque o local da oferta no mapa",
  "pd.description": "Descrição",
  "pd.descriptionPh": "Descreva a oferta...",
  "pd.dealType": "Tipo de oferta",
  "pd.percentOff": "Percentual de desconto (%)",
  "pd.setPrice": "Preço fixo",
  "pd.originalPrice": "Preço original ({sym})",
  "pd.dealPrice": "Preço da oferta ({sym})",
  "pd.discountPct": "Desconto (%)",
  "pd.terms": "Termos e condições",
  "pd.endsOn": "Termina em",
  "pd.lastChance": "Última chance",
  "pd.lastChanceNote": "é automática - sua oferta entra nessa lista sozinha quando faltam menos de 48 horas.",
  "pd.shortDated": "Estoque perto da validade",
  "pd.bestBefore": "Consumir até (opcional)",
  "pd.feature": "Destacar esta oferta",
  "pd.timezone": "Fuso horário",
  "pd.publishAt": "Publicar em",
  "pd.publishHint": "Deixe em branco para publicar agora.",
  "pd.publish": "Publicar oferta",
  "pd.saveChanges": "Salvar alterações",
  "pd.promoNeeded": "Falta o código promocional",
  "pd.promoNeededMsg": "Ofertas online são resgatadas com código promocional - adicione o código que os compradores devem usar.",
  "pd.addDiscount": "Adicione um desconto",
  "pd.addDiscountMsg": "Informe o percentual de desconto desta oferta (1-100).",
  "pd.subtitle": "Compartilhe uma promoção ou oferta perto do vencimento com sua comunidade.",
  "pd.upload": "Toque para enviar ou tirar fotos",
  "pd.uploadHint": "JPG, PNG ou WEBP de até 8MB cada",
  "pd.branchHint": "Marque para incluir um endereço salvo. Você também pode adicionar um pino personalizado no mapa.",
  "picker.searchPh": "Busque um endereço ou local...",
  "picker.find": "Buscar",
  "picker.gps": "Usar meu GPS",
  "picker.hint": "Busque, use o GPS ou toque no mapa para colocar um pino. Arraste o pino para ajustar o ponto exato.",
  "picker.namedPre": "Nomeamos este pino como",
  "picker.editName": "Não está certo? Toque para editar o nome que os compradores veem",
  "pd.editSubtitle": "Ajuste o preço, as datas ou os detalhes e publique sua oferta atualizada.",
  "pd.uploading": "Enviando...",
  "pd.pinHint": "- adicione um pino para cada local onde a oferta está disponível. Os endereços vêm do seu perfil de negócio (uma oferta pode substituí-los abaixo).",
  "pd.codeReq": "Exigir um código de resgate na loja",
  "pd.codeReqHint": "Os compradores recebem um código e um QR exclusivos para mostrar no caixa. Você confirma em Minha conta - assim sabe exatamente quantos clientes o LytePress enviou.",
  "pd.schedule": "Agendar quando vai ao ar",
  "pd.scheduleHint": "Publicação automática em um horário exato no fuso escolhido. Deixe desligado para publicar agora. O vencimento usa a data Termina em acima.",
  "pd.branchFooter": "Opcional - se você pular, colocaremos a oferta no endereço registrado do seu negócio ({place}). Gerencie seus horários em",
  "pd.beating": "Superando {rival}",
  "pd.beatingMsg": "A '{title}' deles está com {rivalDiscount}% de desconto - preparamos uma oferta melhor com {discount}%. Ajuste e publique para ganhar o comprador.",
  "pd.termsDefault": "Válido enquanto durarem os estoques. Não cumulativo com outras ofertas.",
  "common.percentOff": "{n}% de desconto",
  "common.tryAgain": "Tente novamente.",

  "browse.title": "Ver ofertas",
  "browse.nearYou": "Ofertas perto de você",
  "browse.nearPlace": "Ofertas perto de {place}",
  "browse.sortedFrom": "Ordenadas por distância de {place}.",
  "browse.bestLocal": "As melhores economias locais em {place}.",
  "browse.worldwide": "Ótimas ofertas do mundo todo.",
  "browse.radius": "Raio de distância",
  "browse.openNow": "Aberto agora",
  "browse.online": "Online",
  "browse.shortDated": "Perto da validade",
  "browse.clearSearch": "Limpar busca",
  "browse.aiNoMatch": "Nenhuma oferta combinou com essa busca. Tente reformular — por exemplo “ofertas de restaurante abaixo de $20” ou “eletrônicos perto de mim”.",
  "browse.aiUnavailable": "A busca com IA está indisponível agora — mostrando seus resultados normais.",
  "browse.searchFilters": "Filtros da sua busca:",
  "browse.noDeals": "Ainda não há ofertas aqui",
  "browse.noMatch": "Nada corresponde a “{q}”. Tente outras palavras ou outra categoria.",
  "browse.closestMatches": "Sem correspondência exata para “{q}” — estas são as ofertas mais próximas.",
  "browse.didYouMean": "Buscar “{q}” em vez disso",
  "trending.label": "Em alta perto de você",
  "saved.cta": "Salvar esta busca",
  "saved.saved": "Busca salva",
  "saved.section": "Buscas salvas ({n})",
  "saved.done": "“{q}” salvo",
  "saved.doneBody": "Avisaremos quando aparecer uma oferta correspondente.",
  "saved.removed": "“{q}” removido",
  "saved.signIn": "Entre para salvar buscas",
  "browse.browseCats": "Ver categorias",
  "browse.emptyOpenNow": "Nenhuma oferta de negócio aberto agora. Tente desativar “Aberto agora”.",
  "browse.emptyShortDated": "Nenhum item perto da validade agora — volte em breve, eles aparecem quando as lojas baixam o preço de estoque perto da data.",
  "browse.emptyOnline": "Ainda não há ofertas só online — desative o filtro Online para ver ofertas perto de você.",
  "browse.emptyRadius": "Nenhuma oferta a menos de {radius} de você. Tente ampliar o raio.",
  "browse.emptyRadiusPlace": "Nenhuma oferta a menos de {radius} de {place}. Tente ampliar o raio.",
  "browse.emptyDefault": "Nenhuma oferta combina com seus filtros. Remova um filtro ou explore outra categoria.",
  "browse.firstBusiness": "Seja o primeiro negócio em {place}",
  "browse.firstBusinessMsg": "Ninguém publicou aqui ainda — a primeira oferta fica com todos os compradores que chegam, e seu negócio aparece sozinho no topo do mapa.",
  "browse.postFirst": "Publicar a primeira oferta",
  "browse.yourArea": "sua região",

  "card.lastChance": "Última chance",
  "card.shortDated": "Perto da validade",
  "card.online": "Oferta online",
  "card.directions": "Ver rota",
  "card.favourite": "Adicionar aos favoritos",
  "card.inYourCurrency": "na sua moeda",
  "card.locations": "{n} endereços",

  "fav.title": "Favoritos",
  "fav.subtitle": "Ofertas que você salvou para depois.",
  "fav.emptyTitle": "Nenhum favorito ainda",
  "fav.emptyMsg": "Toque no coração de qualquer oferta para salvá-la aqui.",
  "fav.browse": "Ver ofertas",

  "cats.heading": "O que você está procurando?",
  "cats.allDeals": "Todas as ofertas",
  "cats.endingSoon": "Terminam em breve",

  "mydeals.guestTitle": "Suas ofertas pegas ficam aqui",
  "mydeals.guestMsg": "Entre de graça e cada oferta que você pegar — códigos, passes QR e promoções — fica salva aqui em todos os seus aparelhos, com lembretes antes de terminar.",
  "mydeals.createAccount": "Criar conta grátis",
  "mydeals.businessTitle": "Minhas ofertas é para compradores",
  "mydeals.businessMsg": "Gerencie as ofertas que você publicou no seu painel.",
  "mydeals.goDashboard": "Ir para o painel",
  "mydeals.title": "Minhas ofertas",
  "mydeals.subtitle": "Todas as ofertas que você pegou — mostre no negócio para resgatar.",
  "mydeals.emptyTitle": "Nenhuma oferta pega ainda",
  "mydeals.emptyMsg": "Toque em \"Pegar oferta\" em qualquer promoção e ela aparece aqui com seu código, um contador e a rota até a loja.",
  "mydeals.ready": "Prontas para resgatar",
  "mydeals.nothingWaiting": "Nada esperando —",
  "mydeals.grabNew": "pegue uma nova oferta",
  "mydeals.redeemedOn": "resgatada em {date}",
  "mydeals.youSavedAmount": "você economizou {amount}",
  "mydeals.youSavedTotal": "Você economizou {amount}",
  "mydeals.redeemed": "Resgatadas",
  "mydeals.ended": "Encerradas",
  "mydeals.dealEnded": "Esta oferta terminou",
  "mydeals.toRedeem": "{time} para resgatar",
  "mydeals.noExpiry": "Sem validade — resgate quando quiser",
  "mydeals.showAtCheckout": "Mostre no caixa",
  "mydeals.useOnlineCode": "Use seu código na loja online deles",
  "mydeals.showAtBusiness": "Mostre esta oferta no {business}",
  "mydeals.shortDated": "Perto da validade",
  "mydeals.useBy": "consumir até {date}",
  "mydeals.copy": "Copiar",
  "mydeals.codeCopied": "Código copiado",
  "mydeals.pasteAt": "Cole {code} no checkout.",
  "mydeals.yourCode": "Aqui está seu código",
  "mydeals.undone": "Oferta desfeita",
  "mydeals.undoneMsg": "“{title}” foi removida de Minhas ofertas.",
  "mydeals.undoFailed": "Não foi possível desfazer",

  "nearexp.subtitle": "Pegue antes que acabem — economize muito e evite desperdício.",
  "nearexp.grab": "Pegar oferta",
  "nearexp.emptyTitle": "Nada vencendo agora",
  "nearexp.emptyMsg": "Não há ofertas de última chance neste momento. Volte em breve — elas aparecem quando estão perto da data final.",
  "nearexp.browseAll": "Ver todas as ofertas",

  "deal.notFound": "Oferta não encontrada.",
  "deal.back": "Voltar às ofertas",
  "deal.featured": "DESTAQUE",
  "deal.zoom": "Ver imagem completa",
  "deal.zoomHint": "Aperte ou toque duas vezes para ampliar",
  "deal.zoomReset": "Toque duas vezes para redefinir",
  "deal.translate": "Traduzir",
  "deal.translated": "Traduzido",
  "deal.translateFail": "Tradução indisponível",
  "deal.inYourCurrency": "na sua moeda",
  "deal.shortDatedTitle": "Estoque perto da validade",
  "deal.shortDatedUseBy": "consumir até {date}",
  "deal.shortDatedNote": "Está perfeitamente bom, com preço reduzido para ser usado em vez de descartado. Confira se a data serve para você antes de comprar.",
  "deal.onlineTitle": "Oferta online",
  "deal.onlineMsg": "Sem precisar ir à loja — pegue a oferta para ver seu código promocional e use na loja online do {business}.",
  "deal.onlineWorldwide": "Disponível para compradores de qualquer lugar do mundo.",
  "deal.onlineBadge": "Oferta online · resgate de onde estiver",
  "deal.grab": "Pegar oferta",
  "deal.getCode": "Obter meu código de resgate",
  "deal.getPromo": "Obter meu código promocional",
  "deal.signInGrab": "Entre grátis e pegue a oferta",
  "deal.grabbed": "Oferta pega!",
  "deal.promoUse": "Use este código promocional na loja online do {business}:",
  "deal.copyCode": "Copiar código",
  "deal.savedInPre": "Salva em",
  "deal.savedUntilExpiry": "até vencer.",
  "deal.visitToRedeem": "Visite {business} em {location} para resgatar esta oferta antes de acabar.",
  "deal.loginHint": "Conta grátis de comprador · leva 10 segundos · trazemos você de volta",
  "deal.signInToGrab": "Entre para pegar esta oferta",
  "deal.signInToGrabMsg": "Crie uma conta grátis de comprador — trazemos você direto de volta para esta oferta.",
  "deal.couldNotGrab": "Não foi possível pegar a oferta",
  "deal.codeCopied": "Código copiado",
  "deal.pasteAt": "Cole {code} no checkout.",
  "deal.grabUndone": "Oferta desfeita",
  "deal.grabUndoneMsg": "Tudo bem — a oferta continua aqui se você mudar de ideia.",
  "deal.mapUnavailable": "Mapa indisponível",
  "deal.location": "Local",
  "deal.availableAt": "Disponível em {n} endereços",
  "deal.directions": "Ver rota",
  "deal.terms": "Termos e condições",
  "deal.staffCode": "A equipe do {business} vai inserir este código para aplicar seu desconto. Uso único — encontre de novo em",
  "deal.myDeals": "Minhas ofertas",
  "deal.views": "{n} visualizações",

  "auth.verify": "Verificar",
  "auth.login": "Entrar",
  "auth.welcomeBack": "Bem-vindo de volta ao LytePress.",
  "auth.email": "E-mail",
  "auth.password": "Senha",
  "auth.forgot": "Esqueceu a senha?",
  "auth.newShopper": "Novo comprador?",
  "auth.createFree": "Crie uma conta grátis",
  "auth.areBusiness": "Você é um negócio?",
  "auth.registerBusiness": "Cadastre seu negócio",
  "auth.welcomeBackToast": "Bem-vindo de volta!",
  "auth.signedInAs": "Conectado como {name}",
  "auth.loginFailed": "Falha ao entrar",
  "auth.invalidCreds": "Credenciais inválidas",
  "auth.mfaTitle": "Verificação em duas etapas",
  "auth.mfaMsg": "Digite o código de 6 dígitos do seu app autenticador, ou use um código de recuperação.",
  "auth.mfaPlaceholder": "123456 ou código de recuperação",
  "auth.trustDevice": "Confiar neste aparelho por 30 dias",
  "auth.skip2fa": "(sem 2FA na próxima vez)",
  "auth.signupTitle": "Crie sua conta grátis",
  "auth.signupMsg": "Siga seus negócios favoritos e seja avisado no momento em que publicarem uma oferta.",
  "auth.yourName": "Seu nome",
  "auth.passwordMin": "Senha (mín. 6 caracteres)",
  "auth.agreeTo": "Ao criar uma conta você concorda com nossos",
  "auth.and": "e a",
  "auth.haveAccount": "Já tem uma conta?",
  "auth.logIn": "Entrar",
  "auth.signupFailed": "Falha no cadastro",
  "auth.welcomeToLyte": "Bem-vindo ao LytePress!",
  "qa.fixTitle": "Vamos corrigir isto primeiro",
  "qa.uploadBlocked": "Foto não aceita",
  "qa.pending": "Enviado para revisão",
  "qa.pendingMsg": "Sua oferta será publicada assim que nossa equipe aprovar.",
  "qa.watchNotice": "Suas ofertas passam por revisão antes de ir ao ar. Publique normalmente: costumamos aprovar em poucas horas.",
  "qa.title_short": "Dê um título de verdade à oferta (pelo menos 6 caracteres) para os compradores entenderem.",
  "qa.title_long": "Esse título é longo demais: use menos de 90 caracteres.",
  "qa.title_caps": "Não escreva o título TODO EM MAIÚSCULAS: parece spam.",
  "qa.title_emoji": "Emojis demais no título: use no máximo dois.",
  "qa.desc_short": "Adicione uma descrição curta (pelo menos 20 caracteres) explicando o que o comprador leva.",
  "qa.banned": "Esse texto não é permitido no LytePress. Remova conteúdo restrito ou adulto.",
  "qa.links": "Links e redes sociais não são permitidos na descrição: os compradores falam com você pelo seu perfil, onde seus dados já aparecem.",
  "qa.phone": "Deixe os telefones fora da descrição: adicione-os ao perfil do seu negócio.",
  "qa.price_invalid": "O preço e o preço anterior devem ser números.",
  "qa.disc_high": "Um desconto acima de {max}% não é crível e os compradores denunciam. Corrija, por favor.",
  "qa.was_low": "O preço anterior precisa ser maior que o preço da oferta.",
  "qa.disc_mismatch": "Seu % de desconto não corresponde aos preços: {price} de {was} dá {computed}% de desconto, não {discount}%.",
  "qa.dup_title": "Você já tem uma oferta ativa com este mesmo título: edite aquela ou mude este título.",
  "qa.img_small": "Essa foto tem apenas {w}×{h}px e ficaria borrada. Envie pelo menos {minW}×{minH}px.",
  "qa.img_blank": "Essa imagem parece vazia ou de uma só cor. Envie uma foto real da oferta.",
  "qa.img_blurry": "Essa foto parece fora de foco. Envie uma foto mais nítida para mostrar bem a oferta.",
  "qa.img_unreadable": "Não conseguimos ler essa imagem. Envie uma foto JPG, PNG ou WebP.",
  "qa.img_duplicate": "Essa foto já é usada por outro negócio no LytePress. Envie a sua própria foto.",
  "qa.ai_blocked": "Nossa checagem de conteúdo bloqueou esta oferta (conteúdo adulto ou violento). Se for um erro, escreva para support@lytepress.com.",
  "qa.planLimit": "Você atingiu o limite de ofertas do seu plano",
  "qa.seePlans": "Ver planos",
  "qa.coachGood": "Ficou ótima",
  "qa.coachChecking": "Verificando a foto…",
  "qa.coachSmall": "Pequena demais ({w}×{h}px): precisa de {minW}×{minH}px",
  "qa.coachBlurry": "Parece fora de foco: tente uma foto mais nítida",
  "qa.coachBlank": "Parece vazia: envie uma foto real da oferta",
  "invite.signInTitle": "Entre para indicar uma loja",
  "invite.signInMsg": "Criar uma conta gratuita leva segundos e mantém os convites autênticos.",
  "prc.badge": "Planos para negócios",
  "prc.h1": "Cresça mais rápido com o LytePress",
  "prc.sub": "Publique mais ofertas, apareça primeiro e veja como você se compara à loja da esquina.",
  "prc.chipAnalytics": "Análises completas",
  "prc.yourPlan": "Seu plano: {plan}",
  "prc.dealsUsed": "{used} de {limit} ofertas ativas usadas",
  "prc.unlimited": "ilimitadas",
  "prc.monthly": "Mensal",
  "prc.yearly": "Anual",
  "prc.save17": "economize 17%",
  "prc.free": "Grátis",
  "prc.freeSub": "Para começar",
  "prc.f3": "Acompanhamento de visualizações",
  "prc.currentPlan": "Seu plano atual",
  "prc.pro": "Pro",
  "prc.perYear": "/ ano",
  "prc.per30": "/ 30 dias",
  "prc.proYearNote": "Cerca de {monthly}/mês — 2 meses grátis",
  "prc.proMonthNote": "ou {yearly}/ano — economize 17%",
  "prc.p2": "Análises completas e comparação com a concorrência",
  "prc.p4": "Avise todos os seus seguidores sobre novas ofertas",
  "prc.plus": "Elite",
  "prc.plusYearNote": "Fica {monthly}/mês — 2 meses grátis",
  "prc.plusMonthNote": "Para lojas com volume ou várias filiais",
  "prc.activeLife": "Ativo para sempre",
  "prc.renewsOn": "Renova em {date}",
  "prc.endsOn": "Termina em {date}",
  "prc.cancelRenewPro": "Cancelar renovação (mantém o Pro até o fim)",
  "prc.cancelRenew": "Cancelar renovação automática",
  "prc.resumeRenew": "Reativar renovação automática",
  "prc.goYearly": "Assinar anual — {price}",
  "prc.goMonthly": "Assinar mensal — {price}",
  "prc.guarantee": "Reembolso em 14 dias —",
  "prc.guaranteeLink": "sem perguntas",
  "prc.boostTitle": "Precisa de um impulso?",
  "prc.myAccount": "Minha conta",
  "prc.boostRefundPre": "Reembolsável integralmente antes do início do destaque — veja a",
  "prc.refundPolicy": "Política de reembolso",
  "prc.testMode": "Modo de teste — use o cartão 4242 4242 4242 4242, qualquer validade futura e CVC.",
  "prc.sp1": "Todos os preços em dólares americanos. Impostos podem ser somados no checkout conforme o seu país — você vê o total exato antes de pagar.",
  "prc.sp4pre": "Na dúvida? Todo pagamento de assinatura é coberto pela nossa",
  "prc.sp4link": "garantia de reembolso de 14 dias",
  "prc.sp4post": "Compradores nunca pagam para usar o LytePress.",
  "prc.bizOnly": "Apenas contas de negócio",
  "prc.bizOnlyMsg": "Os planos pagos são para negócios que publicam ofertas.",
  "prc.checkoutFail": "Não foi possível iniciar o pagamento",
  "prc.tryAgain": "Tente novamente.",
  "prc.renewOff": "Renovação automática desativada",
  "prc.renewOn": "Renovação automática ativada",
  "prc.subFail": "Não foi possível atualizar a assinatura",
  "ck.title": "Usamos cookies",
  "ck.body": "Usamos cookies essenciais para o LytePress funcionar e outros opcionais para melhorar sua experiência. Veja nossa",
  "ck.privacy": "Política de Privacidade",
  "ck.acceptAll": "Aceitar todos",
  "ck.essential": "Somente essenciais",
  "ck.dismiss": "Fechar",
  "undo.label": "Desfazer",
  "undo.done": "Restaurado",
  "undo.failed": "Não foi possível desfazer — tente de novo",
  "follows.unfollow": "Deixar de seguir",
  "follow.follow": "Seguir",
  "follow.following": "Seguindo",
  "follow.now": "Seguindo {name}",
  "follow.nowMsg": "Avisaremos quando publicarem uma nova oferta.",
  "follow.stopped": "Deixou de seguir {name}",
  "follow.signInTitle": "Entre para seguir",
  "follow.signInMsg": "Crie uma conta gratuita de comprador para receber alertas.",
  "acc.shopperAccount": "Conta de comprador",
  "acc.verifiedSavingsThisMonth": "Economias verificadas este mês",
  "acc.redeemADealCode": "Resgate um código de oferta na loja para começar a acumular economias verificadas.",
  "acc.topSaverEveryBadge": "Maior economizador — todos os emblemas desbloqueados!",
  "acc.recentRedemptions": "Resgates recentes",
  "acc.showPricesInMy": "Mostrar preços na minha moeda",
  "acc.dealsShowAnApproximate": "As ofertas mostram um preço aproximado nesta moeda em todo o aplicativo.",
  "acc.showPricesAsIs": "Mostrar preços como estão",
  "acc.emailPreferences": "Preferências de e-mail",
  "acc.newDealAlerts": "Alertas de novas ofertas",
  "acc.emailMeWhenA": "Envie-me um e-mail quando uma empresa que sigo postar uma nova oferta.",
  "acc.accountSecurityEmailsReceipts": "E-mails de conta e segurança (recibos, redefinições de senha) são sempre enviados.",
  "acc.myRedemptionCodes": "Meus códigos de resgate",
  "acc.businessesYouFollow": "Empresas que você segue",
  "acc.youReNotFollowing": "Você ainda não está seguindo nenhuma empresa. Siga uma empresa para ser notificado quando ela postar uma oferta.",
  "acc.browseBusinesses": "Navegar por empresas",
  "acc.postADeal": "Postar uma oferta",
  "acc.redeemACustomerS": "Resgatar o código de um cliente",
  "acc.whenAShopperShows": "Quando um comprador mostrar seu código ou QR na finalização da compra, escaneie ou digite aqui para confirmar e aplicar seu desconto.",
  "acc.pointTheCameraAt": "Aponte a câmera para o código QR do comprador.",
  "acc.dealsAlsoShowAn": "As ofertas também mostram um preço aproximado nesta moeda em todo o aplicativo.",
  "acc.recommendedLogo": "Recomendado: logo",
  "acc.noCoverPhotoYet": "Ainda sem foto de capa",
  "acc.contactInfo": "Informações de contato",
  "acc.showContactInfoOn": "Mostrar informações de contato no meu perfil público",
  "acc.addAnotherNumber": "Adicionar outro número",
  "acc.saveContactInfo": "Salvar informações de contato",
  "acc.upgradeForMore": "Atualize para mais",
  "acc.myDeals": "Minhas Ofertas",
  "acc.featureNudgeTitle": "Seja o #1 na sua categoria",
  "acc.featureNudgeBody": "Coloque uma das suas ofertas no topo da nossa página inicial para os compradores do seu país — apenas $10 por 24 horas.",
  "acc.featureNudgeCta": "Destacar uma oferta",
  "acc.bookingsTitle": "Reservas em destaque futuras",
  "acc.bookingCancel": "Cancelar",
  "acc.bookingLive": "Ao vivo agora",
  "acc.bookingCancelled": "Reserva cancelada",
  "acc.bookingRefunded": "Cancelada — reembolsada no seu cartão",
  "acc.bookingCancelFailed": "Não foi possível cancelar a reserva",
  "acc.youHavenTPosted": "Você ainda não postou nenhuma oferta.",
  "acc.getListedTitle": "Você ainda não está listado",
  "acc.getListedBody": "Novos negócios só aparecem no LytePress quando publicam uma oferta ativa. Poste sua primeira oferta para ser listado e começar a alcançar compradores perto de você.",
  "acc.postYourFirstDeal": "Poste sua primeira oferta",
  "acc.pendingReview": "Aguardando revisão",
  "acc.undoGrabReleaseThis": "Desfazer captura — liberar este código",
  "acc.enterCodeEG": "Digite o código ex. 7K9M2Q",
  "acc.labelEGPort": "Rótulo (ex. filial de Port of Spain)",
  "acc.removeNumber": "Remover número",
  "acc.shareOfViewersWho": "Porcentagem de visualizadores que reivindicaram esta oferta",
  "acc.duplicateThisDealAnd": "Duplicar esta oferta e editar antes de relançar",
  "acc.couldNotUpdatePreferences": "Não foi possível atualizar as preferências",
  "acc.grabUndone": "Captura desfeita",
  "acc.couldnTUndo": "Não foi possível desfazer",
  "acc.codeRedeemed": "Código resgatado ✓",
  "acc.couldnTRedeem": "Não foi possível resgatar",
  "acc.cameraUnavailable": "Câmera indisponível",
  "acc.allowCameraAccessOr": "Permita o acesso à câmera ou digite o código em vez disso.",
  "acc.saveMoreWasteLess": "Economize mais. Desperdice menos. — continue aproveitando ofertas!",
  "acc.contactInfoSaved": "Informações de contato salvas",
  "acc.couldNotSave": "Não foi possível salvar",
  "acc.pleaseTryAgain": "Por favor, tente novamente.",
  "acc.uploadFailed": "Falha no upload",
  "acc.dealRemoved": "Oferta removida",
  "acc.couldNotRemove": "Não foi possível remover",
  "acc.boostedForDays": "Impulsionado por 7 dias",
  "acc.couldNotStartCheckout": "Não foi possível iniciar o checkout",
  "acc.copyCreated": "Cópia criada",
  "acc.couldNotDuplicate": "Não foi possível duplicar",
  "tfa.twoFactorAuthentication": "Autenticação de dois fatores",
  "tfa.addAnExtraLayer": "Adicione uma camada extra de segurança usando um aplicativo autenticador (Google Authenticator, Authy, 1Password).",
  "tfa.disableFa": "Desativar 2FA",
  "tfa.trustedDevices": "Dispositivos confiáveis",
  "tfa.revokeAllRequireFa": "Revogar todos / exigir 2FA em todos os lugares",
  "tfa.noTrustedDevicesWhen": "Nenhum dispositivo confiável. Ao fazer login, marque “Confiar neste dispositivo por 30 dias” para pular o aviso de 2FA aqui.",
  "tfa.eachCodeWorksOnce": "Cada código funciona uma vez se você perder seu autenticador. Armazene-os em um lugar seguro — eles não serão mostrados novamente.",
  "tfa.copyAllCodes": "Copiar todos os códigos",
  "tfa.iVeSavedThem": "Eu os salvei",
  "tfa.confirmYourPasswordAnd": "Confirme sua senha e um código autenticador atual para desativar o 2FA.",
  "tfa.yourPassword": "Sua senha",
  "tfa.digitCode": "Código de 6 dígitos",
  "tfa.deviceRevoked": "Dispositivo revogado",
  "tfa.thatDeviceWillNeed": "Esse dispositivo precisará de um código 2FA na próxima vez.",
  "tfa.couldNotRevokeDevice": "Não foi possível revogar o dispositivo",
  "tfa.allTrustedDevicesRemoved": "Todos os dispositivos confiáveis removidos",
  "tfa.faWillBeRequired": "2FA será exigido em todos os dispositivos.",
  "tfa.couldNotRevokeDevices": "Não foi possível revogar dispositivos",
  "tfa.couldNotStartFa": "Não foi possível iniciar a configuração do 2FA",
  "tfa.pleaseTryAgain": "Por favor, tente novamente.",
  "tfa.twoFactorAuthenticationEnabled": "Autenticação de dois fatores ativada ✓",
  "tfa.saveYourRecoveryCodes": "Salve seus códigos de recuperação em um lugar seguro.",
  "tfa.couldnTVerifyCode": "Não foi possível verificar o código",
  "tfa.twoFactorAuthenticationDisabled": "Autenticação de dois fatores desativada",
  "tfa.youCanReEnable": "Você pode reativá-lo a qualquer momento.",
  "tfa.couldNotDisableFa": "Não foi possível desativar o 2FA",
  "trips.savedTrips": "Viagens salvas",
  "trips.saveADestinationAnd": "Salve um destino e receba alertas de ofertas antes de chegar.",
  "trips.addTrip": "Adicionar viagem",
  "trips.pickAPopularCity": "Escolha uma cidade popular…",
  "trips.departureOptional": "Partida (opcional)",
  "trips.noTripsYetSave": "Nenhuma viagem ainda — salve uma para receber alertas de ofertas antes de pousar.",
  "trips.orSearchAnyCity": "…ou pesquise qualquer cidade, hotel ou ponto turístico",
  "trips.searchPlace": "Pesquisar lugar",
  "trips.deleteTrip": "Excluir viagem",
  "trips.placeNotFound": "Lugar não encontrado",
  "trips.tryACityHotel": "Experimente uma cidade, hotel ou ponto turístico.",
  "trips.addADestinationAnd": "Adicione um destino e data de início",
  "trips.tripSavedUUfe": "Viagem salva \\u2708\\ufe0f",
  "trips.couldnTSaveTrip": "Não foi possível salvar a viagem",
  "hrs.openingHours": "Horário de funcionamento",
  "hrs.setOnceHereEvery": "Defina uma vez aqui — cada oferta que você postar usará esses horários para mostrar aos compradores quando você está aberto.",
  "hrs.timeZone": "Fuso horário",
  "hrs.copyMondayToAll": "Copiar segunda para todos os dias",
  "hrs.holidayVacationMode": "Modo de férias",
  "hrs.showsYourBusinessAs": "Mostra seu negócio como “Fechado temporariamente” em todos os lugares. Suas ofertas permanecem visíveis.",
  "hrs.reopenDateOptional": "Data de reabertura (opcional)",
  "hrs.messageOptional": "Mensagem (opcional)",
  "hrs.eGBackOn": "ex.: Voltando em 5 de jan — boas festas!",
  "hrs.mondayCopiedToEvery": "Segunda copiada para todos os dias",
  "hrs.tweakAnyDayThat": "Ajuste qualquer dia que seja diferente e salve.",
  "hrs.hoursSaved": "Horários salvos",
  "hrs.yourOpeningHoursNow": "Seu horário de funcionamento agora se aplica a todas as suas ofertas.",
  "hrs.couldNotSave": "Não foi possível salvar",
  "hrs.pleaseTryAgain": "Por favor, tente novamente.",
  "br.businessLocations": "Locais de negócios",
  "br.defaultCurrency": "Moeda padrão",
  "br.yourDefaultCurrencyIs": "Sua moeda padrão está bloqueada.",
  "br.itSFixedTo": "Está fixada em",
  "br.becauseYouAlreadyHave": "porque você já tem ofertas ativas — isso mantém seus preços e resgates passados consistentes. Entre em contato com o suporte se realmente precisar mudar.",
  "br.usedAsTheDefault": "Usada como a moeda padrão para novas ofertas. Atenção: isso é fixo assim que você publica sua primeira oferta.",
  "br.weReMultinationalSet": "Somos multinacionais — defina uma moeda por filial",
  "br.pinEveryBranchLocation": "Fixe cada filial/local onde você opera. Quando você publica uma oferta, esses locais são usados automaticamente — você ainda pode alterá-los por oferta.",
  "br.locationsSaved": "Locais salvos",
  "br.newDealsWillDefault": "Novas ofertas usarão esses locais e moeda como padrão.",
  "br.couldNotSave": "Não foi possível salvar",
  "br.pleaseTryAgain": "Por favor, tente novamente.",
  "tb.recentSearches": "Pesquisas recentes",
  "tb.didYouMean": "Você quis dizer",
  "tb.noQuickMatchesPress": "Nenhuma correspondência rápida — pressione Enter para pesquisar tudo.",
  "tb.searchDeals": "Pesquisar ofertas",
  "tb.toggleAiAssistedSearch": "Alternar pesquisa assistida por IA",
  "tb.findDealsNearMe": "Encontrar ofertas perto de mim",
  "tb.removeFromRecentSearches": "Remover das pesquisas recentes",
  "tb.showDealsEverywhere": "Mostrar ofertas em todos os lugares",
  "tb.searchThisPlace": "Pesquisar este lugar",
  "tb.toggleTheme": "Alternar tema",
  "tb.locationSet": "Localização definida",
  "tb.placeNotFound": "Lugar não encontrado",
  "tb.tryADifferentCity": "Tente uma cidade, município ou nome de lugar diferente.",
  "tb.showingDealsEverywhere": "Mostrando ofertas em todos os lugares",
  "tb.browsingDealsFromAll": "Navegando por ofertas de todos os países.",
  "tb.notSupported": "Não suportado",
  "tb.geolocationIsnTAvailable": "Geolocalização não está disponível neste navegador.",
  "tb.locationFound": "Localização encontrada",
  "tb.locationPermissionDenied": "Permissão de localização negada",
  "tb.allowLocationForThis": "Permita a localização para este site nas configurações da barra de endereços do seu navegador e, em seguida, toque em Perto de Mim novamente.",
  "tb.locationTimedOut": "Tempo de localização esgotado",
  "tb.couldnTGetA": "Não foi possível obter a localização a tempo. Mova-se para um local aberto ou tente novamente — ou escolha uma cidade acima.",
  "tb.locationUnavailable": "Localização indisponível",
  "tb.weCouldnTDetermine": "Não conseguimos determinar sua posição. Tente novamente ou escolha um país/cidade acima.",
  "an.couldNotLoadAnalytics": "Não foi possível carregar análises.",
  "an.performanceOfYourDeals": "Desempenho das suas ofertas e promoções.",
  "an.postADeal": "Postar uma Oferta",
  "an.noDealsYetPost": "Ainda não há ofertas — poste sua primeira oferta para começar a ver análises.",
  "an.yourAverageDiscountIs": "Seu desconto médio é",
  "an.belowTheNearbyAverage": "abaixo da média local de",
  "an.forYourCategoryA": "para sua categoria. Um desconto um pouco maior geralmente gera mais visualizações e compartilhamentos.",
  "an.bestTimeToPost": "Melhor hora para postar",
  "an.newFollowersLastDays": "Novos seguidores (últimos 14 dias)",
  "an.viewsOverTime": "Visualizações ao longo do tempo",
  "an.lastDays": "Últimos 14 dias",
  "an.noViewDataYet": "Ainda não há dados de visualização — eles serão acumulados à medida que os compradores abrirem suas ofertas.",
  "an.yourCompetition": "Sua concorrência",
  "an.liveDeals": "Ofertas ativas",
  "an.avgDiscount": "Desconto médio",
  "an.tipClickARival": "Dica: clique em um rival para comparar suas ofertas ativas lado a lado.",
  "an.redemptionsByDeal": "Resgates por oferta",
  "an.bestPerformer": "Melhor desempenho",
  "an.redemptionsAreCustomersWho": "Resgates são clientes que mostraram seu código LytePress na loja — prova de que a plataforma os enviou até você.",
  "an.redemptionsOverTime": "Resgates ao longo do tempo",
  "an.dealLeaderboard": "Classificação das ofertas",
  "an.byRedemptionRate": "por taxa de resgate",
  "an.viewsByCategory": "Visualizações por categoria",
  "an.noDataYet": "Ainda não há dados.",
  "an.topPerformingDeals": "Ofertas de melhor desempenho",
  "an.sharesOverTime": "Compartilhamentos ao longo do tempo",
  "an.noSharesYetThis": "Ainda não há compartilhamentos — esta linha cresce à medida que os compradores compartilham suas ofertas com amigos.",
  "an.mostSharedDeals": "Ofertas mais compartilhadas",
  "an.noSharesYetThis2": "Ainda não há compartilhamentos — isso se preenche à medida que os compradores usam o botão de compartilhar para divulgar suas ofertas a amigos.",
  "an.loadingComparison": "Carregando comparação…",
  "an.noLiveDeals": "Sem ofertas ativas.",
  "an.matchOrBeat": "Igualar ou superar",
  "an.totalViews": "Total de visualizações",
  "an.totalDeals": "Total de ofertas",
  "an.activeDeals": "Ofertas ativas",
  "an.avgDiscount2": "Desconto médio",
  "an.totalShares": "Total de compartilhamentos",
  "an.inStoreRedemptions": "Resgates na loja",
  "an.nearExpiry": "Próximo do vencimento",
  "reg.registerYourBusiness": "Cadastre seu negócio",
  "reg.startPostingDealsTo": "Comece a postar ofertas para sua comunidade.",
  "reg.whereIsYourBusiness": "Onde está seu negócio?",
  "reg.yourMainLocationYou": "Sua localização principal — você pode adicionar mais filiais após o cadastro em Minha Conta → Localizações.",
  "reg.dealCurrency": "Moeda da oferta",
  "reg.byCreatingAnAccount": "Ao criar uma conta, você concorda com nossos",
  "reg.termsOfUse": "Termos de Uso",
  "reg.privacyPolicy": "Política de Privacidade",
  "reg.alreadyRegistered": "Já está registrado?",
  "reg.logIn": "Entrar",
  "reg.yourName": "Seu nome",
  "reg.businessName": "Nome do negócio",
  "reg.pickYourCity": "Escolha sua cidade",
  "reg.startTypingYourCity": "Comece a digitar sua cidade e escolha-a na lista.",
  "reg.accountCreated": "Conta criada!",
  "reg.registrationFailed": "Falha na criação da conta",
  "rst.setANewPassword": "Defina uma nova senha",
  "rst.chooseAStrongPassword": "Escolha uma senha forte que você não usa em outro lugar.",
  "rst.forgotPassword": "Esqueceu a senha",
  "rst.newPassword": "Nova senha",
  "rst.confirmNewPassword": "Confirme a nova senha",
  "rst.passwordTooShort": "Senha muito curta",
  "rst.useAtLeastCharacters": "Use pelo menos 8 caracteres.",
  "rst.passwordsDonTMatch": "As senhas não coincidem",
  "rst.passwordReset": "Senha redefinida ✓",
  "rst.youCanNowLog": "Agora você pode fazer login com sua nova senha.",
  "rst.couldnTResetPassword": "Não foi possível redefinir a senha",
  "fgt.checkYourEmail": "Verifique seu e-mail",
  "fgt.ifThatEmailIs": "Se esse e-mail estiver registrado, enviamos um link para redefinir sua senha. Ele expira em 45 minutos.",
  "fgt.forgotYourPassword": "Esqueceu sua senha?",
  "fgt.enterYourEmailAnd": "Digite seu e-mail e nós enviaremos um link de redefinição.",
  "fgt.rememberedIt": "Lembrou?",
  "fgt.logIn": "Fazer login",
  "ct.contactUs": "Entre em contato",
  "ct.questionsPartnershipsOrFeedback": "Perguntas, parcerias ou feedback — adoraríamos ouvir você.",
  "ct.sendMessage": "Enviar mensagem",
  "ct.yourName": "Seu nome",
  "ct.emailAddress": "Endereço de e-mail",
  "ct.yourMessage": "Sua mensagem",
  "ct.messageSent": "Mensagem enviada",
  "ct.thanksForReachingOut": "Obrigado por entrar em contato — normalmente respondemos em um dia útil.",
  "st.ourStory": "Nossa História",
  "st.saveMoreWasteLess": "Economize mais. Desperdice menos. Apoie o local.",
  "st.moreThanADirectory": "Mais do que um diretório. Mais do que um site de ofertas.",
  "st.lookingAheadOurGoal": "Olhando para o futuro, nosso objetivo é expandir para o mercado internacional — para que viajantes e turistas possam abrir o LytePress em qualquer lugar do mundo e encontrar instantaneamente as melhores ofertas perto deles, onde quer que sua jornada os leve.",
  "st.thinkOfItThis": "Pense assim — sites como Expedia ajudam você a planejar a viagem; LytePress ajuda você a economizar quando estiver lá, com as melhores ofertas locais perto de você.",
  "st.whetherYouReA": "Seja você um negócio buscando alcançar novos clientes ou um consumidor querendo descobrir o que está acontecendo ao seu redor, o LytePress está aqui para ajudar você a economizar mais, desperdiçar menos e apoiar o local.",
  "st.exploreDeals": "Explore Ofertas",
  "st.contactUs": "Entre em contato",
  "st.supportLocal": "Apoie o local",
  "st.wasteLess": "Desperdice menos",
  "st.communityFirst": "Comunidade em Primeiro Lugar",
  "lg.lytepressOnlyEverCharges": "LytePress só cobra",
  "lg.onASingleDeal": "em uma única oferta, e um",
  "lg.shoppersNeverPayUs": "Compradores nunca nos pagam por uma oferta. Cada oferta é vendida e resgatada pelo negócio que a publicou, então qualquer coisa relacionada aos bens ou serviços — o preço cobrado na loja, qualidade, disponibilidade, trocas ou reembolsos — é entre o comprador e aquele negócio sob sua própria política e a lei de defesa do consumidor local.",
  "lg.ifABusinessRefuses": "Se um negócio se recusar a honrar uma oferta que publicou, nos avise usando a opção de denúncia na oferta ou pela página de Contato. Podemos remover a oferta e o negócio do LytePress, mas não podemos reembolsar uma compra pela qual não recebemos pagamento.",
  "lg.ofThePaymentAnd": "do pagamento e reembolsaremos esse pagamento integralmente. Sem motivo necessário, e se aplica a planos mensais e anuais.",
  "lg.cancelAndWeRefund": "cancele e reembolsamos integralmente.",
  "lg.thePlacementHasAlready": "a colocação já foi entregue aos compradores, então não é reembolsável. Você ainda pode remover ou editar a oferta, mas o gasto permanece utilizado.",
  "lg.ifAPlacementFailed": "Se uma colocação falhou por culpa nossa — nunca foi ao ar, ou a oferta foi escondida por nós durante o período — reembolsamos integralmente ou a reexibimos, conforme sua preferência.",
  "lg.emailUsFromThe": "Envie-nos um e-mail do endereço na sua conta LytePress, ou use a página de Contato, com o nome da sua empresa e a data da cobrança. Respondemos em até 3 dias úteis. Reembolsos aprovados voltam para o método de pagamento original e podem levar de 5 a 10 dias úteis para aparecer, dependendo do seu banco.",
  "lg.refundsIncludeAnyTax": "Os reembolsos incluem qualquer imposto que cobramos no pagamento original. Reembolsamos na moeda em que você foi cobrado — se seu banco converteu o valor, o montante que chega pode diferir ligeiramente devido a taxas de câmbio ou taxas bancárias que não controlamos.\n\nNossos preços são definidos em dólares americanos (USD). No pagamento, nosso provedor de pagamentos pode exibir e cobrar o valor na sua moeda local, convertido pela taxa de câmbio dele. Qualquer transação também pode estar sujeita a encargos de conversão de moeda, taxas bancárias, taxas do emissor do cartão ou outros encargos aplicados pelo seu banco ou provedor de cartão. Estes são adicionais ao preço exibido, estão fora do nosso controle e são de sua responsabilidade.",
  "lg.pleaseTalkToUs": "Por favor, fale conosco antes de abrir uma disputa com seu banco — quase sempre conseguimos resolver mais rápido. Contas com uma contestação não resolvida podem ter recursos pagos pausados até que seja resolvido.",
  "lg.youCanStopUsing": "Você pode parar de usar o LytePress sempre que quiser e excluir suas ofertas da Minha Conta. Cancelar uma conta não reembolsa automaticamente um pagamento já realizado — use as regras acima.",
  "lg.billingQuestionsReachUs": "Dúvidas sobre cobrança? Entre em contato pela página de Contato.",
  "lg.lytepressHelpsShoppersDiscover": "LytePress ajuda os compradores a descobrir ofertas locais e globais e permite que as empresas publiquem ofertas. Você deve ser capaz de formar um contrato vinculativo para usar o serviço e concorda em usá-lo legalmente.",
  "lg.youAreResponsibleFor": "Você é responsável por manter seu login e quaisquer códigos de autenticação de dois fatores seguros. Contas comerciais são responsáveis pela precisão das ofertas, preços, filiais e detalhes de contato que publicam.",
  "lg.dealsAreOfferedBy": "As ofertas são oferecidas pelas empresas que as publicam, não pelo LytePress. Disponibilidade, preços e resgates na loja são responsabilidade dessa empresa. Códigos de resgate são para uso único, a menos que indicado de outra forma.",
  "lg.refundPolicy": "Política de Reembolso",
  "lg.donTPostUnlawful": "Não publique conteúdo ilegal, enganoso ou que infrinja direitos, não tente interromper o serviço ou misuse os dados de outros usuários.",
  "lg.weMayUpdateThese": "Podemos atualizar estes termos ou o serviço e podemos suspender contas que os violem. O uso contínuo após as mudanças significa que você aceita os termos atualizados.",
  "lg.questionsAboutTheseTerms": "Dúvidas sobre estes termos? Entre em contato pela página de Contato.",
  "lg.toRunTheService": "Para executar o serviço — mostrando ofertas relevantes perto de você, enviando notificações de ofertas que você optou por receber, processando resgates e pagamentos, e mantendo sua conta segura.",
  "lg.ifYouUseNear": "Se você usar \"Perto de Mim\" ou Modo Turista, usamos a localização que você fornece (ou a localização do seu dispositivo, com permissão) apenas para encontrar ofertas próximas. Você sempre pode escolher uma localização manualmente.",
  "lg.ipAndGeo": "Para melhorar sua experiência, usamos seu endereço IP para estimar sua localização aproximada (normalmente seu país), para que o mapa, as ofertas e o idioma da interface fiquem por padrão onde você está, em vez de começar sempre em outro lugar. Isso é uma aproximação e pode ser impreciso; você pode alterar seu país, cidade e idioma a qualquer momento, e essa escolha prevalece sobre a estimativa. A localização GPS precisa só é usada se você tocar em \"Perto de Mim\" e conceder permissão. As estimativas de localização por IP são guardadas brevemente, apenas para agilizar visitas seguintes, e expiram automaticamente.",
  "lg.analyticsTitle": "Análises",
  "lg.analyticsBody": "Usamos software de análise de terceiros que respeita a privacidade (por exemplo, Plausible Analytics) para entender como o site é usado — como quais páginas são visitadas e quais recursos são populares. Isso pode envolver um fornecedor de análise externo a processar dados de uso anonimizados e agregados em nosso nome. Essas ferramentas não usam cookies e não o rastreiam em outros sites nem criam um perfil pessoal seu. Podemos adicionar, alterar ou remover fornecedores de análise ao longo do tempo.",
  "lg.notResponsibleForDeals": "A LytePress é apenas uma plataforma de anúncios. Ofertas, preços, produtos, serviços e condições de resgate são criados, oferecidos e cumpridos inteiramente pelas empresas independentes que os publicam — não são ofertas nossas. Não vendemos, fornecemos, endossamos nem garantimos qualquer oferta, e não somos responsáveis pela disponibilidade, exatidão, qualidade, segurança ou legalidade do que uma empresa oferece, nem pelo fato de uma empresa recusar, alterar ou não cumprir uma oferta. Qualquer compra ou resgate é um contrato entre você e essa empresa; qualquer disputa sobre uma oferta é entre você e ela. Verifique os detalhes de cada oferta e os termos da empresa antes de confiar nela.",
  "lg.privacyQuestionsReachUs": "Dúvidas sobre privacidade? Entre em contato pela página de Contato.",
  "lg.whatLytepressChargesFor": "1. O que o LytePress cobra",
  "lg.dealsAreNotSold": "2. Ofertas não são vendidas pelo LytePress",
  "lg.boostsAndFeaturedPlacements": "4. Impulsionamentos e Colocações em Destaque",
  "lg.howToRequestA": "5. Como solicitar um reembolso",
  "lg.taxesCurrencyAndFees": "6. Impostos, moeda e taxas",
  "lg.chargebacks": "7. Estornos",
  "lg.cancellingYourAccount": "8. Cancelando sua conta",
  "lg.contact": "9. Contato",
  "lg.usingLytepress": "1. Usando o LytePress",
  "lg.accounts": "2. Contas",
  "lg.dealsRedemptions": "3. Ofertas e resgates",
  "lg.payments": "4. Pagamentos",
  "lg.acceptableUse": "5. Uso aceitável",
  "lg.changesTermination": "6. Mudanças e rescisão",
  "dd.savedTo": "Salvo em",
  "dd.myDeals": "Minhas Ofertas",
  "dd.save": "Salvar",
  "dd.saved": "Salvo",
  "dd.favourite": "Salvar oferta",
  "dd.backToDeals": "Voltar para as ofertas",
  "dd.showThisAtCheckout": "Mostrar isso na finalização",
  "dd.changedYourMindUndo": "Mudou de ideia? Desfazer a captura",
  "bp.businessNotFound": "Negócio não encontrado.",
  "bp.browseBusinesses": "Navegar por negócios",
  "bp.loading": "Carregando…",
  "bp.allBusinesses": "Todos os negócios",
  "bp.noLiveDealsRight": "Nenhuma oferta ativa no momento — siga para ser notificado quando postarem uma.",
  "bp.verifiedBusiness": "Negócio verificado",
  "bp.businessLocation": "Localização do negócio",
  "bl.localGlobalMerchants": "Comerciantes locais e globais",
  "bl.discoverBusinesses": "Descubra negócios",
  "bl.followYourFavouriteShops": "Siga suas lojas favoritas e nunca perca uma oferta nova.",
  "bl.noBusinessesMatchThese": "Nenhum negócio corresponde a esses filtros.",
  "bl.viewProfile": "Ver perfil",
  "dsh.seePricesInYour": "Ver preços na sua moeda",
  "dsh.pickYourCurrencyAnd": "Escolha sua moeda e cada oferta mostrará uma estimativa instantânea no dinheiro que você usa.",
  "dsh.chooseCurrency": "Escolher moeda…",
  "psx.confirmingYourPayment": "Confirmando seu pagamento…",
  "psx.thisOnlyTakesA": "Isso leva apenas um momento.",
  "psx.paymentSuccessful": "Pagamento bem-sucedido!",
  "psx.yourUpgradeIsNow": "Seu upgrade agora está ativo. Obrigado por apoiar a LytePress.",
  "psx.goToMyAccount": "Ir para Minha Conta",
  "psx.backToPremium": "Voltar para Premium",
  "pcx.checkoutCancelled": "Finalização cancelada",
  "pcx.noWorriesYouHave": "Sem preocupações — você não foi cobrado.",
  "pcx.backToPremium": "Voltar para Premium",
  "nf.thisPageTookA": "Esta página fez um desvio",
  "nf.thePageYouRe": "A página que você está procurando não existe ou pode ter expirado. Vamos te levar de volta ao que importa.",
  "nf.backHome": "Voltar para casa",
  "nf.browseDeals": "Navegar por ofertas",
  "nf.goBack": "Voltar",
  "cat.exploreByCategory": "Explorar por categoria",
  "cat.browseAll": "Navegar por tudo",
  "cat.grabThemFast": "Pegue rápido",
  "md.undoGrab": "Desfazer captura",
  "bd.aiSearch": "Busca AI",
  "bd.findingTheBestMatches": "Encontrando as melhores correspondências…",
  "bd.nearMe": "Perto de mim",
  "bd.openNow": "aberto agora",
  "bd.nearMe2": "perto de mim",
  "bd.noExactMatchesSearching": "Nenhuma correspondência exata — buscando por significado…",
  "lm.googleMapsApiKey": "Chave da API do Google Maps não configurada.",
  "lm.loadingMap": "Carregando mapa...",
  "pdx.movePhotoLeft": "Mover foto para a esquerda",
  "pdx.movePhotoRight": "Mover foto para a direita",
  "pdx.eGLyte": "ex. LYTE20",
  "pdx.couldNotLoadDeal": "Não foi possível carregar a oferta",
  "pdx.pleaseTryAgain": "Por favor, tente novamente.",
  "pdx.photosAdded": "Fotos adicionadas",
  "ip.addLytepressToYour": "Adicione o LytePress à sua tela inicial",
  "ip.addToHomeScreen": "Adicionar à Tela Inicial",
  "ip.fasterAccessToDeals": "Acesso mais rápido às ofertas perto de você e seus códigos de resgate — sem necessidade de loja de aplicativos.",
  "rev.verifiedReviews": "Avaliações verificadas",
  "rev.verifiedRedemption": "Resgate verificado",
  "rev.redeemOneOfThis": "Resgate uma das ofertas deste negócio na loja para deixar uma avaliação verificada.",
  "rev.noReviewsYetBe": "Ainda sem avaliações — seja o primeiro após resgatar uma oferta.",
  "rev.shareHowTheDeal": "Compartilhe como foi a oferta (opcional)…",
  "rev.replyPubliclyToThis": "Responder publicamente a esta avaliação…",
  "rev.pickAStarRating": "Escolha uma classificação por estrelas",
  "rev.tapStarsToRate": "Toque em 1–5 estrelas para avaliar este negócio.",
  "rev.yourVerifiedReviewIs": "Sua avaliação verificada está agora ativa.",
  "rev.couldnTPostReview": "Não foi possível postar a avaliação",
  "rev.replyIsEmpty": "A resposta está vazia",
  "rev.writeAShortReply": "Escreva uma resposta curta primeiro.",
  "rev.replyPosted": "Resposta postada",
  "rev.shoppersCanNowSee": "Os compradores agora podem ver sua resposta.",
  "rev.couldnTPostReply": "Não foi possível postar a resposta",
  "tm.touristMode": "Modo Turista",
  "tm.localPrices": "Preços locais",
  "tm.noneYet": "nenhum ainda",
  "tm.saveThisBase": "Salvar esta base",
  "tm.iMVisitingShow": "Estou visitando — mostre as melhores ofertas perto de mim",
  "tm.hotelLandmarkOrAddress": "Hotel, ponto de referência ou endereço…",
  "tm.setBaseLocation": "Definir localização base",
  "tm.exitTouristMode": "Sair do modo turista",
  "tm.removeBase": "Remover base",
  "tm.touristModeOn": "Modo Turista ativado ✈️",
  "tm.showingDealsNearYou": "Mostrando ofertas perto de você, com preços na sua moeda, com direções em um toque.",
  "tm.typeTheHotelLandmark": "Digite o hotel, ponto de referência ou área onde você está para ver ofertas nas proximidades.",
  "tm.baseUpdated": "Base atualizada 📍",
  "tm.placeNotFound": "Local não encontrado",
  "tm.tryAHotelName": "Tente um nome de hotel, ponto de referência ou endereço.",
  "rpt.reportThisDeal": "Reportar esta oferta",
  "rpt.tellUsWhatS": "Diga-nos o que está errado para que nossa equipe possa revisar.",
  "rpt.reportDeal": "Reportar oferta",
  "rpt.addAnyDetailsOptional": "Adicionar detalhes (opcional)",
  "rpt.spamOrMisleading": "Spam ou enganoso",
  "rpt.wrongOrFakePrice": "Preço errado ou falso",
  "rpt.offensiveOrInappropriate": "Ofensivo ou inadequado",
  "rpt.expiredNoLongerAvailable": "Expirado / não disponível",
  "rpt.somethingElse": "Outra coisa",
  "rpt.signInToReport": "Faça login para reportar",
  "rpt.pleaseLogInTo": "Por favor, faça login para reportar uma oferta.",
  "rpt.thanksForTheReport": "Obrigado pelo relatório",
  "rpt.ourTeamWillReview": "Nossa equipe irá revisar este negócio.",
  "rpt.couldNotSubmitReport": "Não foi possível enviar o relatório",
  "dlp.mapUnavailableNoApi": "Mapa indisponível (sem chave de API)",
  "dlp.loadingMap": "Carregando mapa…",
  "dlp.useBusinessDefaultCurrency": "Usar moeda padrão do negócio",
  "dlp.openingHoursOverrideOptional": "Horário de funcionamento opcional",
  "dlp.placeNotFound": "Local não encontrado",
  "dlp.tryADifferentAddress": "Tente um endereço ou nome de local diferente.",
  "dlp.gpsUnavailable": "GPS indisponível",
  "dlp.searchAnAddressInstead": "Pesquise um endereço em vez disso.",
  "dlp.pinnedYourLocation": "Localização fixada",
  "dlp.couldnTGetLocation": "Não foi possível obter a localização",
  "dlp.allowLocationAccessOr": "Permita o acesso à localização ou pesquise um endereço.",
  "shb.shareDeal": "Compartilhar negócio",
  "shb.shareThisDeal": "Compartilhar este negócio",
  "shb.linkCopied": "Link copiado",
  "shb.shareItWithFriends": "Compartilhe com amigos!",
  "shb.couldnTCopyLink": "Não foi possível copiar o link",
  "shs.shareMySavings": "Compartilhar minhas economias",
  "shs.copied": "Copiado!",
  "shs.pasteItAnywhereTo": "Cole em qualquer lugar para convidar amigos.",
  "shs.couldnTCopy": "Não foi possível copiar",
  "shs.myLytepressSavings": "Minhas economias no LytePress",
  "rgc.monthlyRedemptionGoal": "Meta de resgates mensal",
  "rgc.redemptionsMonth": "resgates / mês",
  "rgc.setAMonthlyTarget": "Defina uma meta mensal para acompanhar seus resgates e manter a equipe motivada.",
  "rgc.goalReachedNicelyDone": "Meta alcançada — muito bem!",
  "obc.dismissChecklist": "Descartar lista de verificação",
  "obc.profileLinkCopied": "Link do perfil copiado",
  "obc.pasteItOnWhatsapp": "Cole no status do WhatsApp, bio do Instagram ou na vitrine da sua loja.",
  "obc.hereSYourLink": "Aqui está seu link",
  "obc.addYourLogo": "Adicione seu logo",
  "obc.addAContactNumber": "Adicione um número de contato",
  "obc.pinYourLocation": "Fixe sua localização",
  "obc.postYourFirstDeal": "Publique seu primeiro negócio",
  "obc.shareYourProfileLink": "Compartilhe o link do seu perfil",
  "rr.alertsEnabled": "Alertas ativados",
  "rr.youLlBeNotified": "Você será notificado sobre novos negócios (demonstração).",
  "pc.popularDestinations": "Destinos populares",
  "sb.logOut": "Sair",
  "st.para1": "Acreditamos que descobrir ótimos negócios locais deve ser fácil, gratificante e acessível a todos.",
  "st.para2": "Todos os dias, as empresas lançam novos produtos, criam ofertas especiais, organizam eventos, realizam promoções e oferecem serviços valiosos que muitos clientes nunca conhecem. Ao mesmo tempo, os consumidores estão constantemente em busca de maneiras de economizar dinheiro, descobrir novas experiências e se conectar com suas comunidades.",
  "st.para3": "Criamos a LytePress para unir esses dois mundos.",
  "st.para4": "A LytePress é uma plataforma onde negócios locais podem mostrar promoções, eventos, sorteios, ofertas especiais e oportunidades, enquanto os consumidores podem descobrir novas maneiras de economizar, comprar, jantar, explorar e se envolver com os negócios ao seu redor.",
  "st.para5": "Também estamos comprometidos em reduzir o desperdício desnecessário, ajudando as empresas a promover produtos em excesso e próximos da data de validade que ainda têm valor, criando benefícios tanto para os negócios quanto para os consumidores.",
  "st.valSupportLocal": "Conectando comunidades com os negócios ao seu redor.",
  "st.valWasteLess": "Promovendo produtos em excesso e próximos da data de validade que ainda têm valor.",
  "st.valCommunity": "Uma comunidade crescente que recompensa o consumo inteligente e o empreendedorismo.",
  "st.sustainable": "Sustentável",
  "an.nViews": "{n} visualizações",
  "an.nViewsNDeals": "{v} visualizações · {d} ofertas",
  "an.nSharesNViews": "{s} compartilhamentos · {v} visualizações",
  "dc.seeAllIn": "Ver todas as ofertas de {name}",
  "acc.nOfMLiveDeals": "{n} / {m} ofertas ativas",
  "cat.nLiveDeals": "{n} ofertas ativas",
  "cat.nCategories": "{n} categorias",
  "bl.allCategories": "Todas as categorias",
  "reg.and": "e",
  "acc.planLabelPlan": "plano {plan}",
  "acc.showInCurrency": "Mostrar em {code} — {label}",
  "home.slide1a": "Ótimas Ofertas.",
  "home.slide1b": "Menos Desperdício.",
  "home.slide1sub": "Descubra ofertas de negócios locais e resgate itens perto do vencimento antes que acabem.",
  "home.slide1badge": "Economize até 70%",
  "home.slide2a": "Compre Local.",
  "home.slide2b": "Economize Mais.",
  "home.slide2sub": "Apoie os negócios locais e encontre as ofertas que eles têm perto de você.",
  "home.slide2badge": "Até 60% de desconto",
  "home.slide3a": "Todas as Ofertas.",
  "home.slide3b": "Em um Só Lugar.",
  "home.slide3sub": "Todas as categorias em um só lugar, para você nunca perder uma oferta local.",
  "home.slide3badge": "Flash 50% de desconto",
  "home.vp1t": "Economize Dinheiro",
  "home.vp1x": "Ótimos descontos nos seus itens favoritos",
  "home.vp2t": "Reduza o Desperdício",
  "home.vp2x": "Ajude as empresas a reduzir o desperdício de alimentos e produtos",
  "home.vp3t": "Apoie o Local",
  "home.vp3x": "Fortaleça as empresas locais na sua comunidade",
  "home.slideN": "Slide {n}",
  "vf.title": "Verificação de negócios",
  "vf.riskyNote": "Essas categorias precisam de verificação antes que você possa postar nelas: {list}",
  "vf.upload": "Enviar documento",
  "vf.sent": "Documentos enviados",
  "vf.sentMsg": "Vamos revisá-los e te enviaremos um e-mail — geralmente em um dia.",
  "vf.failed": "Não foi possível enviar isso",
  "vf.pendingMsg": "Estamos revisando seus documentos — te enviaremos um e-mail quando estiver pronto.",
  "vf.verifiedMsg": "Seu negócio está verificado. O selo azul aparece no seu perfil e no diretório.",
  "vf.rejected": "Não conseguimos verificar seu negócio com esses documentos. Tente fotos mais claras.",
  "vf.independent": "Vendedor independente",
  "vf.verifiedTag": "Negócio verificado",
  "bl.allCountries": "Todos os países",
  "bl.nDeals": "{n} ofertas",
  "sidebar.plusActive": "Elite ativo",
  "sidebar.forLife": "Para a vida toda",
  "cat.Bakery": "Padaria",
  "cat.Electronics": "Eletrônicos",
  "cat.Food & Beverages": "Alimentos & Bebidas",
  "cat.Groceries": "Mercados",
  "cat.Health & Beauty": "Saúde & Beleza",
  "cat.Restaurants": "Restaurantes",
  "bl.nBusinesses": "{n} negócios",
  "cat.subScoped": "Explore ofertas selecionadas em todas as categorias em {scope}. Toque em um bloco para saber mais.",
  "cat.subGlobal": "Explore ofertas selecionadas em todas as categorias do mundo todo. Toque em um bloco para saber mais.",
  "cat.nLiveRightNow": "{n} ao vivo agora",
  "browse.verifiedOnly": "Apenas verificados",
  "bl.verifiedOnly": "Apenas verificados",
  "map.verifiedOnly": "Apenas verificados",
  "browse.emptyVerified": "Nenhum negócio verificado tem ofertas ativas aqui ainda — tente desativar “Apenas verificados”.",
  "trust.whatsThis": "O que é isso?",
  "trust.title": "O que significa “verificado”",
  "trust.verifiedTitle": "Negócio verificado",
  "trust.independentTitle": "Vendedor independente",
  "trust.limitsTitle": "O que não promete",
  "trust.limitsBody": "O selo é sobre quem eles são, não uma garantia do produto, do serviço ou do preço. Sempre verifique os termos da oferta antes de comprar.",
  "trust.reportTitle": "Algo errado?",
  "trust.reportBody": "Toque em Reportar em qualquer oferta. Dois relatos sinalizam para nossa equipe, e removemos ofertas que enganam os compradores.",
  "trust.footer": "Categorias sensíveis — saúde, eventos, tecnologia e automotivo — só podem ser postadas por negócios verificados.",
  "apl.title": "Apelar uma decisão",
  "apl.subtitle": "Algo que erramos? Responda uma vez e resolveremos aqui.",
  "apl.appeal": "Apelar",
  "apl.send": "Enviar apelação",
  "apl.cancel": "Cancelar",
  "apl.reason": "Nossa razão",
  "apl.placeholder": "Conte-nos o que aconteceu — quanto mais específico, mais rápido podemos resolver.",
  "apl.onceNote": "Você pode apelar de cada decisão uma vez. Respondemos por e-mail.",
  "apl.sent": "Apelação enviada",
  "apl.sentMsg": "Vamos analisar e te enviar um e-mail.",
  "apl.failed": "Não foi possível enviar isso",
  "apl.pending": "Estamos revisando sua apelação",
  "apl.granted": "Resolvido — concordamos com você",
  "apl.declined": "Mantivemos nossa decisão",
  "apl.deal": "Oferta removida: {title}",
  "apl.watch": "Suas ofertas são revisadas antes de serem publicadas",
  "apl.watchDetail": "Isso acontece após duas ofertas serem removidas.",
  "apl.suspension": "Sua conta está suspensa",
  "apl.verification": "Verificação não foi aprovada",
  "qa.appeal_short": "Por favor, nos diga o que aconteceu em pelo menos 20 caracteres — isso nos ajuda a resolver rapidamente.",
  "qa.appeal_once": "Você já apelou disso uma vez — responderemos por e-mail.",
  "acc.activeDeals": "Ofertas ativas",
  "acc.totalViews": "Total de visualizações",
  "acc.totalClaims": "Total de reivindicações",
  "acc.nClaims": "{n} reivindicações",
  "acc.nConversion": "{n} conversão",
  "acc.goesLive": "Vai ao ar {when}",
  "adn.title": "Complementos — pague só pelo que precisa",
  "adn.sub": "Os planos cobrem os recursos que não nos custam nada. Estes são limitados ou dão trabalho real, então são vendidos à parte: pagamento único, sem assinatura.",
  "adn.slotsTitle": "5 slots extra de ofertas",
  "adn.slotsBody": "Mais cinco slots de ofertas ativas além do seu plano, por 30 dias. Compre novamente quando quiser: eles somam.",
  "adn.slotsCta": "Adicionar 5 slots — {price}",
  "adn.slotsActive": "{n} slots extra ativos",
  "adn.boostTitle": "Impulsionar uma oferta",
  "adn.boostCta": "Impulsionar em Minha conta",
  "adn.verifyTitle": "Verificação prioritária",
  "adn.verifyBody": "Seus documentos de registro vão para a frente da fila de análise em vez de esperar a vez.",
  "adn.verifyCta": "Análise prioritária — {price}",
  "adn.verifyDone": "Você tem análise prioritária — vemos seus documentos primeiro.",
  "adn.verifiedAlready": "Seu negócio já está verificado.",
  "adn.oneOff": "Cobranças únicas, não assinaturas",
  "srv.title": "Pelo que você pagaria primeiro?",
  "srv.sub": "Toque em tudo que se aplica. Suas respostas decidem o que construímos e quanto custa.",
  "srv.slots": "Mais slots de ofertas",
  "srv.analytics": "Análises e comparativos",
  "srv.placement": "Posição no topo",
  "srv.verification": "Selo de verificado",
  "srv.followers": "Avisar meus seguidores",
  "srv.saved": "Obrigado — anotado.",
  "bo.title": "Impulsionar esta oferta",
  "bo.checking": "Verificando o que está livre perto de você…",
  "bo.slotsLine": "{n} de {limit} slots patrocinados livres num raio de {km}km do seu negócio",
  "bo.choose": "Escolher",
  "bo.note": "Uma lista nunca mostra mais de 3 ofertas patrocinadas, então os negócios se alternam no topo a cada hora. Exclusivo é a única opção que não se divide.",
  "bo.boostTitle": "Boost",
  "bo.boostBody": "Um dos 3 slots patrocinados por 7 dias, para clientes num raio de 10km.",
  "bo.reachTitle": "Boost + Alcance",
  "bo.reachBody": "O mesmo slot, mas você também aparece para clientes até 25km — para negócios aonde as pessoas viajam.",
  "bo.exclTitle": "Exclusivo",
  "bo.exclBlocked": "Exclusivo precisa de todos os slots livres e {n} boost(s) ainda estão ativos. Livre em {date}.",
  "bst.kindReach": "Alcance {km}km",
  "bst.kindExclusive": "Exclusivo",
  "bst.shareCrowded": "{n} outros boosts coincidiram com a sua área, então você teve um lugar no topo cerca de {pct}% do tempo. Com Exclusivo seria o tempo todo.",
  "bst.shareClear": "Você teve um lugar no topo todo o tempo — nada mais competia por perto.",
  "tfa.enable2fa": "Ativar 2FA",
  "fn.title": "Como os compradores interagem com suas ofertas",
  "fn.subtitle": "Três passos reais. Sem pontuação de conversão inventada.",
  "fn.views": "Visualizações",
  "fn.grabs": "Aproveitamentos",
  "fn.redeemed": "Resgatados na loja",
  "fn.viewsNote": "Vezes que suas páginas de ofertas foram abertas — contadas uma vez por comprador por dia.",
  "fn.grabsNote": "Compradores que tocaram em Aproveitar, para que a oferta seja salva no bolso.",
  "fn.redeemedNote": "Códigos que você escaneou na loja — o único passo que prova uma visita real.",
  "fn.grabRate": "{n}% das visualizações",
  "fn.redeemRate": "{n}% dos aproveitamentos",
  "fn.honestTitle": "O que esses números podem e não podem te dizer",
  "fn.honestBody": "Podemos contar apenas as páginas de ofertas abertas, aproveitamentos e códigos que você escaneia na loja. Não conseguimos ver as visitas que não aproveitaram uma oferta, o que um cliente gastou ou se ele voltou. Ofertas sem código não têm passo resgatado.",
  "fn.sourcesTitle": "De onde vieram suas visualizações",
  "fn.sourcesEmpty": "Ainda não há fontes de visualização. Compartilhe uma oferta e volte a checar.",
  "fn.sourcesNote": "Compartilhamentos são links que você ou os compradores enviaram. Direto significa que não conseguimos identificar de onde a visita começou.",
  "fn.last30Days": "Últimos 30 dias",
  "fn.nViewsPercent": "{n} visualizações · {p}%",
  "fn.nGrabs": "{n} aproveitamentos",
  "fn.nRedeemed": "{n} resgatados",
  "fn.directionsTitle": "{n} pessoas pediram direções",
  "fn.directionsNote": "Toques em Direções no mapa ou na página da oferta — o sinal mais forte de que alguém se dirigiu à sua loja.",
  "fn.nDirections": "{n} direções",
  "map.homeMapNote": "A visualização do mapa é sua casa agora",
  "map.classicHome": "Casa clássica",
  "map.homeClassicNote": "Prefere o mapa como sua tela inicial?",
  "map.openMap": "Usar mapa como casa",
  "map.alertMe": "Me avise aqui",
  "map.alertSignIn": "Faça login gratuitamente para receber alertas nesta área.",
  "map.alertSaved": "Você receberá um aviso para {area}",
  "map.alertSavedDesc": "{n} ofertas estão ativas aqui agora, a cerca de {km} km. Gerencie alertas em Seguindo.",
  "map.alertFailed": "Não foi possível salvar o alerta dessa área. Por favor, tente novamente.",
  "map.thisArea": "Esta área",
  "map.areasSection": "Alertas de área ({n})",
  "map.areaRadius": "A cerca de {km} km",
  "map.areaRemoved": "Alertas desativados para {area}",
  "map.shareDialogTitle": "Compartilhe esta visualização do mapa",
  "map.sharePreview": "{n} ofertas em vista — economize até {best}%",
  "map.sharePreviewNote": "É assim que o link deve parecer quando alguém o receber.",
  "map.shareNoteLabel": "Adicione uma nota (opcional)",
  "map.shareNotePlaceholder": "Almoço — encontramos perto da confeitaria?",
  "map.shareNow": "Compartilhar link",
  "map.boostedPin": "Impulsionado",
  "map.shareCancel": "Cancelar",
  "home.mapTitle": "Ofertas no mapa",
  "home.mapSubtitle": "{n} ofertas marcadas onde você pode realmente entrar",
  "home.mapOpenFull": "Abrir o LyteMap completo",
  "home.mapNote": "Pinos vermelhos terminam em 24 horas. Pinos com borda dourada são promovidos pela loja.",
  "ct.subject": "Assunto",
  "ct.sending": "Enviando…",
  "ct.messageTooShort": "Por favor, adicione um pouco mais de detalhes para que possamos ajudar.",
  "ct.messageFailed": "Não conseguimos enviar isso",
  "ct.tryAgainLater": "Por favor, tente novamente em um momento.",
  "ct.replyNote": "Lemos todas as mensagens e geralmente respondemos em um dia útil.",
  "lg.boostsIntro": "Um Boost compra atenção por um período fixo, então o tempo importa.",
  "lg.boostStartsNowLabel": "Começa no momento em que você paga:",
  "lg.boostStartsNow": "um Boost entra ao vivo na sua oferta imediatamente e dura pelos dias que você comprou, então não pode ser cancelado para reembolso uma vez comprado. Se você comprar um por engano, entre em contato conosco no mesmo dia e resolveremos.",
  "lg.refundTimeline": "Os pagamentos com cartão são processados pelo nosso processador de pagamentos (Stripe) — nós nunca vemos ou armazenamos os detalhes do seu cartão. Reembolsos aprovados são enviados de volta para o mesmo cartão e geralmente aparecem dentro de 5 a 10 dias úteis, dependendo do seu banco.",
  "bst.reportTitle": "O que seus boosts fizeram",
  "bst.reportSub": "Cada boost ao lado do mesmo período de tempo logo antes de começar.",
  "bst.running": "Em andamento",
  "bst.finished": "Concluído",
  "bst.directionsShort": "Direções",
  "bst.reportNote": "Ofertas impulsionadas se revezam no topo — a ordem muda a cada hora para que cada loja impulsionada tenha uma parte justa.",
  "bst.slotsLeft": "{n} de {limit} slots de boost disponíveis para {category} em {city} agora",
  "bst.slotsFull": "Os {limit} slots de boost para {category} em {city} estão ativos",
  "bst.slotsNote": "Limitamos os boosts ativos a {limit} num raio de {km}km de cada negócio, para que um pin dourado continue se destacando.",
  "bst.slotsLeftNear": "{n} de {limit} slots de boost disponíveis para {category} num raio de {km}km do seu negócio",
  "bst.slotsFullNear": "Os {limit} slots de boost para {category} num raio de {km}km do seu negócio estão ativos",
  "bst.nextFree": "O próximo slot abre {when} — um boost dura 7 dias completos a partir da compra.",
  "bst.notifyMe": "Avise-me quando um slot abrir",
  "bst.notifyQueued": "Você está na lista — enviaremos um e-mail assim que abrir um slot de {category}.",
  "bst.ownBoostLive": "\"{title}\" já está com boost em {category} — um boost ativo por categoria, assim você não disputa consigo mesmo.",
  "adn.boostBody": "No topo da navegação, busca, mapa, ofertas que estão acabando e as ofertas da página inicial por 7 dias. Apenas 3 impulsos podem rodar ao mesmo tempo dentro de 10km da sua loja, então o selo continua tendo significado.",
  "bo.exclBody": "Você ocupa os 3 espaços e se classifica até 25km: sua é a única oferta patrocinada na sua categoria nas proximidades. Máximo de duas semanas, depois a categoria se abre novamente.",
  "bo.close": "Fechar",
  "adn.featTitle": "Em destaque na página inicial",
  "adn.featBody": "Sua oferta ocupa o único espaço em Destaque da sua categoria na página inicial por 24 horas — a única oferta em destaque nessa categoria, mostrada a compradores do mundo todo. O impulso te eleva na navegação, no mapa e na busca; Destaque te coloca na página inicial.",
  "adn.featCta": "Destacar a partir da Minha Conta",
  "card.sponsored": "Patrocinado",
  "lg.listingDiscretion": "Manter o LytePress interessante significa que revisamos o que é publicado. Podemos editar, arquivar ou remover qualquer anúncio e retirar o acesso ao serviço, quando julgarmos necessário — por exemplo, conteúdo que pareça impreciso, inseguro, duplicado ou fora de lugar. Normalmente, informaremos a empresa o motivo, embora não precisemos pedir primeiro.",
  "lg.listingModerationRecords": "O conteúdo que você publica — ofertas, fotos e detalhes da empresa — é revisado como parte da operação do serviço, e uma cópia de um anúncio que retiramos pode permanecer em nossos registros internos por um período para que possamos lidar com apelos, disputas e problemas recorrentes.",
  "lg.termsOfUse": "Termos de Uso",
  "lg.privacyPolicy": "Política de Privacidade",
  "bo.excl14Title": "Exclusivo · 2 semanas",
  "bo.excl14Body": "O mesmo bloqueio, pago antecipadamente por toda a quinzena e mais barato do que duas semanas individuais. Depois disso, a categoria reabre para todos.",
  "bo.extendTitle": "Estender este impulso",
  "bo.extendLine": "Válido até {date} — dias extras são adicionados ao final, você não perde nada.",
  "bo.addDays": "Adicionar {n} dias",
  "bo.extendNote": "Os dias extras começam quando sua corrida atual termina, então seu negócio nunca sai dos spots patrocinados no meio da semana.",
  "bo.exclRunway": "Você manteve Exclusivo por {held} de {max} dias seguidos. A categoria reabre para todos até {date}.",
  "sr.title": "Slots patrocinados perto de você",
  "sr.sub": "Apenas {limit} spots patrocinados são exibidos ao mesmo tempo em cada categoria dentro de {km}km da sua loja. Veja o que está livre agora.",
  "sr.loading": "Verificando os slots ao redor da sua loja…",
  "sr.open": "{n} de {limit} livres dentro de {km}km",
  "sr.full": "Todos os {limit} ativos agora",
  "sr.fullNext": "Todos os {limit} ativos — o próximo abre {date}",
  "sr.exclusiveHeld": "Uma loja mantém Exclusivo aqui até {date}",
  "sr.watch": "Assistir",
  "sr.watching": "Assistindo",
  "sr.watchOn": "Nós te avisaremos assim que um slot de {category} abrir",
  "sr.watchOff": "Parou de assistir {category}",
  "sr.buyPass": "Compre um Boost Pass — {price}",
  "sr.passesHeld": "{n} Boost Pass pronto para uso",
  "sr.note": "Um Boost Pass é um impulso pago antecipadamente pelo preço normal — mantenha até que um slot abra, depois use com um toque. Ele nunca expira e não pula a fila, então o limite permanece justo.",
  "fp.title": "Aqui está seu spot em Destaque",
  "fp.honest": "Este é o único espaço em Destaque para a sua categoria — a única oferta em destaque que os compradores veem ali, no mundo todo.",
  "fp.note": "Destaque é a linha da página inicial — um espaço por categoria. Escolha o seu país (visto por compradores locais) ou o mundo todo (visto em todo lugar). Dura 24 horas; comprar novamente enquanto está ativo adiciona mais um dia ao final.",
  "fp.reachLocal": "Meu país",
  "fp.reachLocalNote": "No topo da sua categoria para compradores daqui",
  "fp.reachGlobal": "No mundo todo",
  "fp.reachGlobalNote": "No topo da sua categoria em todo lugar",
  "fp.today": "Hoje (começar agora)",
  "fp.pickDay": "Comece hoje ou reserve um dia",
  "fp.notNow": "Agora não",
  "fp.buy": "Destaque — {price}",
  "bo.extendSame": "Adiciona {n} dias a mais ao que você já está rodando.",
  "bo.extendToReach": "Adiciona {n} dias e amplia seu alcance de 10km para 25km durante toda a campanha.",
  "bo.extendToExclusive": "Adiciona {n} dias e ocupa os 3 spots patrocinados, até 25km.",
  "bo.extendNarrower": "Adiciona dias, mas reduz seu alcance de volta para 10km.",
  "pc.placeholder": "Código de desconto",
  "pc.apply": "Aplicar",
  "pc.remove": "Remover código",
  "pc.invalid": "Esse código não é válido.",
  "pc.appliedPct": "{code} — {n}% de desconto",
  "pc.appliedAmt": "{code} — R${n} de desconto",
  "pc.haveCode": "Tem um código de desconto?",
  "prc.f2": "Um pin no mapa & perfil público",
  "prc.p3": "Até 3 locais fixados",
  "acc.frontPageForDays": "Em destaque por 7 dias",
  "br.limitNote": "{plan} cobre {cap} localizações fixas. Pro fixa 3 e Elite é ilimitado.",
  "br.overLimit": "Você tem mais localizações salvas do que {plan} cobre ({cap}). Tudo que já foi publicado permanece no mapa — faça um upgrade para salvar as alterações aqui.",
  "acc.archived": "Arquivado",
  "acc.archivedWhy": "Removido:",
  "acc.archivedNoReason": "Nenhum motivo foi dado — pergunte-nos e explicaremos.",
  "acc.explainAppeal": "Explique o que aconteceu →",
  "sl.shareMsg": "Temos {n} ofertas agora — dê uma olhada:",
  "sl.copy": "Copiar link",
  "sl.copied": "Link copiado",
  "sl.copiedNote": "Cole em qualquer lugar — ele abre direto na sua página da loja.",
  "bst.kindFeatured": "Destaque na página inicial, {km}km",
  "bo.extendLocked": "Você está rodando {kind} — adicione dias a esse para não perdê-lo. Você pode trocar assim que a corrida terminar.",
  "fp.slots": "O espaço em Destaque para a sua categoria está livre — garanta-o por 24 horas.",
  "fp.full": "O espaço em Destaque para a sua categoria está ocupado agora — o próximo abre em {date}. Há um espaço por categoria.",
  "prc.chipFeatured": "Colocação prioritária",
  "prc.chipCredits": "Impulsos e Destaques como complementos",
  "prc.boostLeft": "{n} Passes de Impulso restantes",
  "prc.p5": "Relatórios de promoção em cada Impulso ou Destaque",
  "prc.boostBody": "Impulsos e Destaques nunca são incluídos em um plano — compre-os apenas quando precisar. Impulsione qualquer oferta única por {price} para fixá-la no topo do Navegar e no mapa por 7 dias — encontre o botão de Impulso em suas ofertas em",
  "acc.usedBoostPass": "Usou um Pass de Impulso — {n} restantes.",
  "acc.couldNotUseYour": "Não foi possível usar seu Pass de Impulso",
  "prc.plusIncludesPro": "Tudo no Pro, mais:",
  "prc.b4": "Suporte prioritário — suas mensagens pulam a fila",
  "sl.title": "Seu link da loja",
  "sl.sub": "Um link para tudo que você tem — {n} ao vivo agora. Cole no WhatsApp e ele mostra o nome da sua loja, logo e quantas ofertas estão disponíveis.",
  "sl.on": "Link ativado",
  "sl.off": "Link desativado",
  "sl.switchedOn": "Seu link da loja está ao vivo",
  "sl.switchedOff": "Seu link da loja está desativado",
  "sl.offNote": "Seu link está desativado, então não será aberto para ninguém. Ative-o novamente sempre que quiser compartilhar.",
  "sl.needVerified": "Os links da loja vêm com verificação — é o que impede que outra pessoa negocie em seu nome. Envie seus documentos e o seu será ativado automaticamente, baseado no nome da sua empresa.",
  "sl.getVerified": "Verifique-se",
  "sl.dealLinks": "Cada oferta também recebe seu próprio link — aqui está “{title}”:",
  "prc.b3": "Colocação prioritária em Navegar e no mapa, compartilhada de forma justa",
  "prc.sp3": "Os limites de ofertas ao vivo contam ofertas que estão publicadas ou agendadas e ainda não expiraram — Grátis 2, Pro 15, Elite 100. O Elite também cobre 25 localizações fixas. Esses limites são uso justo, não uma barreira: se sua rede precisar de mais, envie um e-mail para o suporte e nós aumentaremos em sua conta. A colocação prioritária é um critério de desempate entre ofertas que estão à mesma distância do comprador, compartilhada de forma justa entre lojas Elite — nunca coloca uma loja acima de outra que está genuinamente mais próxima.",
  "prc.firstTermOnly": "{price} por este período com seu código — renova por {full}",
  "prc.promoTermOnly": "Os códigos se aplicam ao período que você compra. As renovações são cobradas automaticamente pelo preço usual, então o desconto vale apenas para este primeiro período.",
  "prc.sp2": "Os planos se renovam automaticamente para que sua loja nunca fique fora do ar. Você paga por um período (Pro {pro} / 30 dias ou {proYear} / ano; Elite {plus} / 30 dias ou {plusYear} / ano); seu cartão é guardado com segurança pelo nosso provedor de pagamentos, Stripe, e cobrado automaticamente no início de cada novo período — até você desativar a renovação automática, o que pode fazer a qualquer momento nesta página. Se uma cobrança de renovação falhar, seu plano continua funcionando durante um período de carência de 3 dias enquanto tentamos novamente. Um código de desconto aplica-se apenas ao período em que é usado — as renovações são cobradas pelo preço da lista. Os planos nunca incluem Boosts ou colocações em destaque: esses são encargos únicos, não assinaturas.",
  "lg.proSubscription": "plano (Pro ou Elite)",
  "lg.placementShoppersUseLytepress": "colocação, além de um pequeno número de complementos avulsos (slots extras de ofertas, um Boost Pass ou verificação prioritária). Compradores usam o LytePress gratuitamente.",
  "lg.ifYouReNot": "Se você não estiver satisfeito com um plano, nos avise dentro de",
  "lg.afterDaysASubscription": "Um plano é adquirido por um período (30 dias ou um ano) e se renova automaticamente. Seu cartão é guardado com segurança pelo nosso provedor de pagamentos, Stripe — nunca por nós — e cobrado no início de cada novo período para que seu plano continue sem interrupção. Você pode desativar a renovação automática a qualquer momento na página de Preços; você mantém tudo o que pagou até o período atual terminar, e nada é cobrado depois disso. Se uma cobrança de renovação falhar, os benefícios do seu plano continuam durante um período de carência de 3 dias enquanto tentamos novamente, após o qual a conta passa para Grátis. Após 14 dias, o pagamento por um período já em andamento não é reembolsável, e você mantém tudo o que pagou até que esse período termine.",
  "lg.ifARenewalCharge": "Um código de desconto aplica-se apenas ao período em que foi utilizado: as renovações são cobradas pelo preço da lista. Você pode ver sua data de renovação e desativar a renovação automática a qualquer momento na página de Preços. Se uma renovação te surpreender, entre em contato conosco — onde um período pago não for utilizado, normalmente reembolsaremos como cortesia.",
  "lg.premiumSubscriptionsAndDeal": "Planos, Boosts, colocações em destaque e complementos são cobrados através do nosso processador de pagamentos. Boosts e colocações em destaque nunca estão incluídos em um plano — são compras avulsas separadas e são limitadas em número em cada área, portanto uma colocação só está disponível enquanto um slot perto da sua loja estiver livre. O negócio Elite e as permissões de localização são limites de uso justo, e \"colocação prioritária\" significa apenas que um negócio Elite é exibido primeiro quando duas ofertas estão à mesma distância do comprador — nunca coloca uma loja acima de outra que está genuinamente mais próxima. As taxas são mostradas antes da compra. Impostos podem ser aplicáveis com base na sua localização. Reembolsos são cobertos por nosso",
  "lg.accountDetailsNameEmail": "Detalhes da conta (nome, email, função), informações do perfil da empresa (nome da empresa, categoria, localização, números de contato, logo/capa) e suas preferências (moeda de exibição, empresas seguidas, localização). Se você habilitar a autenticação de dois fatores, armazenamos um segredo criptografado e códigos de recuperação hash. Se você adicionar uma chave de acesso, armazenamos sua chave pública e um contador de assinatura. Se você enviar feedback ou uma mensagem de suporte, mantemos a mensagem e seu email apenas se você forneceu um, para que possamos responder.",
  "lg.businessContactDetailsAre": "Os detalhes de contato da empresa são mostrados publicamente apenas quando a empresa opta por torná-los públicos. O link público de uma loja verificada (/s/nome-da-loja) e seus links de ofertas mostram o nome, logo e ofertas ao vivo daquela loja para qualquer pessoa com o link — a loja pode desativar esse link a qualquer momento. Não vendemos seus dados pessoais. Compartilhamos dados limitados com nosso processador de pagamentos para concluir compras.",
  "lg.passwordsAreHashedFa": "Senhas são hash, segredos de dois fatores são criptografados em repouso, e ações sensíveis têm limite de taxa. Se você adicionar uma chave de acesso, armazenamos apenas sua chave pública e um contador — nunca sua impressão digital, rosto ou PIN do dispositivo, que nunca saem do seu dispositivo. Nenhum sistema é perfeitamente seguro, então, por favor, use uma senha forte e adicione uma chave de acesso ou 2FA.",
  "lg.youCanEditYour": "Você pode editar seu perfil, ocultar suas informações de contato públicas, gerenciar dispositivos confiáveis e chaves de acesso, ativar ou desativar 2FA, desativar seu link público da loja e ajustar notificações a qualquer momento em Minha Conta. Para ter sua conta e dados pessoais excluídos, envie um email para support@lytepress.com e nós tomaremos providências dentro de 30 dias.",
  "lg.proSubscriptionsDayMoney": "3. Planos — como funciona a cobrança e reembolso em 14 dias",
  "lg.lawDisputes": "7. Lei e disputas",
  "lg.termsContact": "8. Contato",
  "auth.or": "ou",
  "fb.button": "Feedback",
  "fb.title": "Diga-nos o que você pensa",
  "fb.sub": "Qualquer coisa quebrada, faltando ou brilhante — chega direto até nós. Nenhuma conta necessária.",
  "fb.typeBug": "Algo está quebrado",
  "fb.typeIdea": "Eu tenho uma ideia",
  "fb.typeCompliment": "Algo que eu amo",
  "fb.typeOther": "Algo mais",
  "fb.messagePlaceholder": "Diga-nos o que aconteceu, ou o que você gostaria de ver…",
  "fb.emailLabel": "Email (opcional — apenas para que possamos responder)",
  "fb.send": "Enviar",
  "fb.sent": "Obrigado — isso está conosco",
  "fb.sentNote": "Uma pessoa lê cada um desses. Vamos responder se você deixou um email.",
  "fb.failed": "Não foi possível enviar isso",
  "fb.tooShort": "Mais algumas palavras e saberemos o que corrigir",
  "pk.title": "Chaves de acesso",
  "pk.sub": "Faça login com Face ID, sua impressão digital ou seu PIN do dispositivo. Sua senha continua funcionando como backup.",
  "pk.add": "Adicionar uma chave de acesso",
  "pk.added": "Chave de acesso adicionada",
  "pk.addedNote": "Na próxima vez, toque em \"Entrar com uma chave de acesso\" — sem senha para digitar.",
  "pk.removed": "Chave de acesso removida",
  "pk.remove": "Remover",
  "pk.none": "Nenhuma chave de acesso ainda. Adicione uma e este dispositivo pode fazer login sem uma senha.",
  "pk.unsupported": "Este navegador ainda não suporta chaves de acesso — sua senha e 2FA ainda funcionam normalmente.",
  "pk.cancelled": "Cancelado",
  "pk.failed": "Isso não funcionou",
  "pk.lastUsed": "Último uso {date}",
  "pk.never": "Ainda não usado",
  "pk.signIn": "Entrar com uma chave de acesso",
  "pk.loginFailed": "Não foi possível fazer login",
  "pk.loginFailedNote": "Tente sua senha ou adicione uma chave de acesso em Minha Conta primeiro.",
  "cq.need": "Precisa de mais espaço?",
  "cq.title": "Peça limites mais altos",
  "cq.sub": "Elite cobre {deals} ofertas ao vivo e {branches} locais como uso justo. Diga-nos o que sua rede realmente precisa e nós ajustaremos.",
  "cq.deals": "Ofertas ao vivo que você precisa",
  "cq.branches": "Locais que você precisa",
  "cq.notePlaceholder": "Algo que devemos saber — quantas filiais você tem, o que você está planejando…",
  "cq.send": "Enviar solicitação",
  "cq.sentTitle": "Solicitação enviada",
  "cq.sentNote": "Vamos analisar e te enviar um e-mail — geralmente em um dia.",
  "cq.pending": "Limites maiores solicitados — vamos te enviar um e-mail",
  "cq.failed": "Não conseguimos enviar isso",
  "fb.context": "Envie a página e o dispositivo que estou usando",
  "fb.contextOn": "Ajuda a reproduzir: {path}, além do tamanho da tela, idioma e navegador. Sem cookies ou dados pessoais.",
  "fb.contextOff": "Só receberemos sua mensagem.",
  "pn.title": "Bloqueie sua loja neste dispositivo",
  "pn.body": "Suas ofertas estão ativas. Adicione uma chave de acesso e apenas seu rosto, impressão digital ou PIN do dispositivo podem entrar nesta loja — sem senha para adivinhar ou roubar.",
  "pn.add": "Adicionar uma chave de acesso",
  "pn.notNow": "Agora não",
  "tm.sortingAround": "Classificando ofertas em {place}.",
  "tm.cancel": "Cancelar",
  "tm.nearPlace": "perto de {place}",
  "tm.you": "você",
  "tm.changeBase": "mudar base",
  "tm.yourBases": "Suas bases:",
  "tm.switchedTo": "Mudou para {label}",
  "pw.placeholder": "Senha",
  "pw.show": "Mostrar senha",
  "pw.hide": "Ocultar senha",
  "pw.veryWeak": "Muito fraca",
  "pw.weak": "Fraca",
  "pw.fair": "Está melhorando",
  "pw.strong": "Forte",
  "pw.veryStrong": "Muito forte",
  "pw.crackTime": "levaria {time} para ser quebrada",
  "pw.needsWork": "Ainda não é forte o suficiente",
  "prc.bestValue": "MELHOR VALOR",
  "qa.profanity": "Por favor, retire as palavras de baixo calão primeiro — encontramos {words}. O LytePress é lido por famílias e funcionários de lojas, então as ofertas e avaliações devem ser limpas.",
  "sl.customTitle": "Escolha seu próprio link",
  "sl.customPlus": "Incluído com Elite — escolha as palavras após /s/ você mesmo.",
  "sl.customOwned": "Você possui este complemento — mude as palavras após /s/ quando quiser.",
  "sl.customOffer": "Seu link é construído a partir do nome da sua empresa. Quer palavras diferentes após /s/? Custa {price} uma vez, é seu para sempre — ou grátis no Elite.",
  "sl.customBuy": "Nomeie meu link — {price}",
  "sl.customEdit": "Edite meu link",
  "sl.customSave": "Salvar link",
  "sl.customCancel": "Cancelar",
  "sl.customPlaceholder": "nome-da-sua-loja",
  "sl.customSaved": "Seu novo link está ativo",
  "adn.linkTitle": "Escolha seu próprio link da loja",
  "adn.linkBody": "Escolha as palavras após /s/ você mesmo em vez de usar o nome da sua empresa — mais curto para dizer em voz alta, mais fácil de colar. Seu para sempre, um pagamento.",
  "adn.linkCta": "Nomeie meu link — {price}",
  "adn.linkIncluded": "Incluído com Elite",
  "adn.linkSetIt": "Defina meu link",
  "adn.linkNeedsVerify": "Links de loja precisam de verificação — envie seus documentos primeiro.",
  "rst.thisResetLinkIs": "Este link de redefinição é inválido, já foi usado ou expirou. Por favor, solicite um novo em",
  "rst.minChars": "Use pelo menos {n} caracteres para esta conta.",
  "acc.tabDeals": "Meus descontos",
  "acc.tabShop": "Minha loja",
  "acc.tabRedeem": "Resgatar",
  "acc.tabAccount": "Conta",
  "sec.title": "Detalhes de login",
  "sec.sub": "Altere a senha ou o e-mail com o qual você faz login.",
  "sec.pwTitle": "Senha",
  "sec.pwNote": "Alterá-la desconecta todos os outros dispositivos.",
  "sec.pwCta": "Alterar senha",
  "sec.currentPw": "Senha atual",
  "sec.newPw": "Nova senha",
  "sec.pwSave": "Salvar senha",
  "sec.pwChanged": "Senha alterada",
  "sec.pwChangedNote": "Todos os outros dispositivos foram desconectados.",
  "sec.emailTitle": "E-mail de login",
  "sec.emailCta": "Alterar e-mail",
  "sec.newEmail": "Novo endereço de e-mail",
  "sec.emailSave": "Enviar confirmação",
  "sec.emailConfirmNote": "Enviaremos um link para o novo endereço. Nada muda até você clicar nele.",
  "sec.emailSent": "Verifique sua nova caixa de entrada",
  "sec.emailSentNote": "Enviamos um link de confirmação para {email}. Ele funciona por 24 horas.",
  "sec.emailPending": "Aguardando {email} para confirmar.",
  "ses.title": "Dispositivos conectados",
  "ses.sub": "Desconecte qualquer coisa que você não reconheça.",
  "ses.idleNote": "Desconectado automaticamente após {n} horas sem atividade.",
  "ses.thisDevice": "Este dispositivo",
  "ses.signOutAll": "Desconectar em todos os lugares",
  "ses.signOutDevice": "Desconectar este dispositivo",
  "ses.signedOutDevice": "Esse dispositivo foi desconectado",
  "ses.signedOutAll": "Desconectado em todos os lugares",
  "ses.signedOutAllNote": "Todos os outros dispositivos precisarão fazer login novamente.",
  "ses.empty": "Nenhum outro dispositivo está conectado.",
  "auth.endedIdle": "Você foi desconectado após um período de inatividade. Faça login para continuar de onde parou.",
  "auth.endedRevoked": "Este dispositivo foi desconectado. Faça login novamente para continuar.",
  "pd.maxDays": "Seu plano roda uma oferta por até {n} dias. Renove com um toque quando acabar.",
  "acc.renew": "Renovar",
  "acc.renewTitle": "Coloque esta oferta de volta no mapa com uma nova contagem regressiva",
  "acc.renewDone": "Contagem regressiva reiniciada",
  "acc.renewRelisted": "De volta ao mapa",
  "acc.renewNote": "Esta oferta roda por mais {n} dias.",
  "pd.clampedTitle": "Data de término antecipada",
  "pd.clampedNote": "Seu plano oferece uma promoção por até {n} dias, então é aqui que essa termina. Renove com um toque para mantê-la ativa.",
  "nd.title": "Ainda não há ofertas aqui",
  "nd.sub": "Diga-nos onde você está e vamos buscar lojas no mapa perto de você. É assim que decidimos onde bater à porta a seguir.",
  "nd.townPlaceholder": "Sua cidade, ex. Arima",
  "nd.emailPlaceholder": "Email (opcional — avisaremos quando as ofertas chegarem)",
  "nd.cta": "Quero ofertas aqui",
  "nd.thanks": "Anotado",
  "nd.thanksNote": "Adicionamos {place} à lista.",
  "nd.onTheList": "Você está na lista",
  "nd.onTheListNote": "Vamos te enviar um email assim que lojas perto de você começarem a postar.",
  "map.shareNear": "Compartilhar as ofertas mais próximas",
  "map.shareNearMsg": "Ofertas perto de {place} agora no LytePress:",
  "promo.title": "\"Estamos no LytePress\" gráfico",
  "promo.sub": "Uma imagem quadrada com seu código QR — poste no Instagram, Facebook ou no seu status do WhatsApp.",
  "promo.cta": "Baixar imagem",
  "promo.saved": "Imagem salva",
  "promo.savedNote": "Poste e quem escanear vai direto para suas ofertas.",
  "acc.weeklyRoundup": "Resumo semanal",
  "acc.dealsNearYouWeekly": "Ofertas perto de você, uma vez por semana",
  "acc.fiveClosestDeals": "As cinco ofertas mais próximas, enviadas por email uma vez por semana. Não mais que isso.",
  "acc.digestOn": "Resumo semanal ativado",
  "acc.digestOff": "Resumo semanal desativado",
  "acc.digestOnNote": "Vamos te enviar as ofertas mais próximas uma vez por semana.",
  "acc.digestOffNote": "Sem mais emails semanais. Emails da conta ainda serão enviados.",
  "cat.Travel & Tours": "Viagens & Passeios",
  "sr.watchAnother": "Veja outra categoria:",
  "sr.pickCategory": "Escolha uma categoria",
  "prc.startFree": "Comece grátis — sem cartão necessário",
  "prc.switchAtTermEnd": "Mudar para {plan} quando meu período terminar",
  "prc.noProration": "Sem prorrata — seu período atual já está pago, então a mudança aguarda até que termine.",
  "prc.cancelScheduled": "Cancelar a mudança agendada",
  "prc.scheduled": "Agendado: {plan}",
  "prc.scheduledOn": "Entrará em vigor em {date}. Nada muda antes disso.",
  "prc.scheduleCancelled": "Mudança agendada cancelada — nada muda.",
  "prc.scheduledBanner": "Você está mudando para {plan} em {date}. Tudo que você pagou permanece ativo até lá.",
  "del.title": "Excluir minha conta",
  "del.subShopper": "Remove sua conta, códigos salvos, favoritos e sessões. As avaliações que você deixou permanecem na loja como “Usuário excluído”.",
  "del.subBusiness": "Você pode excluir uma vez que não tenha ofertas ativas ou agendadas e nenhum período pago ainda em andamento. Tudo será removido: sua loja, ofertas, fotos e pins.",
  "del.cta": "Excluir minha conta",
  "del.warning": "Isso é permanente. Não podemos recuperar a conta, suas ofertas ou suas fotos.",
  "del.passwordPlaceholder": "Sua senha",
  "del.typeDelete": "Digite DELETE para confirmar",
  "del.confirmCta": "Excluir permanentemente",
  "del.keepAccount": "Manter minha conta",
  "del.done": "Conta excluída",
  "del.doneNote": "Tudo foi removido. Obrigado por experimentar o LytePress.",
  "lg.deletingYourAccount": "7. Excluindo sua conta",
  "lg.deleteShopper": "Os compradores podem excluir sua conta a qualquer momento em Minha Conta. Isso remove a conta, códigos salvos, favoritos e sessões ativas. As avaliações que você escreveu permanecem no perfil da loja, mostradas como “Usuário excluído”, porque a classificação de uma loja também é informação de outros compradores.",
  "lg.deleteBusiness": "As empresas só podem excluir uma conta uma vez que não tenha ofertas ativas ou agendadas, e nenhum período pago ainda em andamento. Isso protege os compradores de encontrarem pins de mapa para uma loja que não existe mais, e protege você de desperdiçar tempo que já pagou: exclua ou deixe suas ofertas expirarem, cancele a renovação e exclua assim que o período terminar. Escreva para nós se precisar sair antes.",
  "lg.deleteAdmin": "Podemos fechar uma conta nós mesmos — por exemplo, por violações repetidas de políticas ou fraude — incluindo uma com ofertas ativas. Nós enviaremos um e-mail com o motivo quando fizermos isso.",
  "msg.title": "Mensagens",
  "msg.sub": "Tudo que enviamos vai parar aqui — responda no app e chega direto até nós.",
  "msg.new": "novo",
  "msg.noSubject": "Mensagem",
  "msg.you": "Você",
  "msg.replyPlaceholder": "Escreva sua resposta…",
  "msg.send": "Enviar resposta",
  "msg.sent": "Resposta enviada — nós voltaremos para você.",
  "prc.b5": "Seu próprio link da loja, lytepress.com/s/seu-nome (lojas verificadas)",
  "sec.nudgeTitle": "Proteja sua loja com uma chave de acesso",
  "sec.nudgeBody": "Sua conta guarda suas ofertas, seus preços e seu histórico de pagamentos. Uma chave de acesso (Face ID ou impressão digital) ou código de dois passos torna uma senha roubada inútil.",
  "sec.nudgePasskey": "Adicionar uma chave de acesso",
  "sec.nudge2fa": "Ativar dois passos",
  "st.mission": "Nossa missão é simples: ajudar as pessoas a gastar menos nas coisas que já compram, ajudar lojas locais a preencher horários vazios e desperdiçar menos comida e estoque ao longo do caminho.",
  "an.lockedTitle": "As informações do Pro estão bloqueadas",
  "an.lockedCta": "Veja o que o Pro adiciona",
  "af.footerLink": "Análises",
  "af.badge": "Análises da loja",
  "af.title": "O que suas análises mostram",
  "af.subtitle": "Toda loja recebe os números principais. Pro e Elite adicionam a camada de coaching — tendências, timing e benchmarks.",
  "af.colMetric": "O que você vê",
  "af.colFree": "Grátis",
  "af.colPaid": "Pro & Elite",
  "af.rowTotals": "Ofertas ativas, expiradas e quase expiradas",
  "af.rowTraffic": "Total de visualizações, capturas, compartilhamentos e seguidores",
  "af.rowDiscount": "Desconto médio e taxa de conversão",
  "af.rowCategory": "Visualizações divididas por categoria",
  "af.rowTopDeals": "Seu ranking de melhores ofertas",
  "af.rowFunnel": "Funil: visualizações para capturas para resgates",
  "af.rowRedemptions": "Total de resgates e direções tomadas",
  "af.rowGoal": "Rastreador de metas de resgate mensal",
  "af.rowTrends": "Tendências de visualizações, compartilhamentos e seguidores ao longo do tempo",
  "af.rowBestTime": "Melhor hora e melhor dia para postar",
  "af.rowWoW": "Movimento semana a semana",
  "af.rowBenchmark": "Como seus descontos se comparam às lojas próximas",
  "af.rowRedemptionDetail": "Detalhes de resgate para cada oferta",
  "af.rowMostShared": "Ranking dos mais compartilhados",
  "af.note": "Pro e Elite veem exatamente as mesmas análises — nada é retido para o plano maior. No Grátis, as linhas bloqueadas ainda aparecem, borradas, para que você sempre saiba o que está lá.",
  "af.seePlans": "Veja planos e preços",
  "af.openMine": "Abra minhas análises",
  "af.compareLink": "Veja quais análises cada plano oferece",
  "an2.doNext": "Faça isso a seguir",
  "an2.tipNearExpiry": "{n} oferta(s) expiram em 48 horas — renove ou ajuste o preço antes que expirem",
  "an2.tipDiscount": "Seus descontos estão cerca de {gap}% abaixo das lojas próximas na sua categoria — tente {target}% na sua próxima oferta",
  "an2.tipBestTime": "Seus compradores costumam olhar por volta de {time} em {day} — poste sua próxima oferta pouco antes disso",
  "an2.tipRedeem": "Apenas {rate}% dos códigos resgatados são usados na loja — um lembrete ou um prazo fecha essa lacuna",
  "an2.tipViewsDown": "As visualizações caíram {n}% em relação à semana passada — uma oferta nova as eleva mais rápido do que qualquer outra coisa",
  "an2.tipGrabRate": "Apenas {rate}% dos visualizadores pegam suas ofertas — um preço mais atraente ou uma foto mais clara geralmente resolve isso",
  "an2.tipShares": "Ninguém compartilhou suas ofertas ainda — envie o link da sua loja para seus próprios clientes uma vez e veja o que acontece",
  "an2.tipAllGood": "Nada precisa ser corrigido hoje — seus números estão saudáveis. Poste algo novo para mantê-los assim",
  "an2.proMore": "O Pro cuida do resto para você",
  "an2.grabs": "Códigos pegados",
  "an2.subVsLastWeek": "{n}% em relação à semana passada",
  "an2.subOfViews": "{n}% dos visualizadores pegam",
  "an2.subOfGrabs": "{n}% dos que foram resgatados",
  "an2.subExpired": "{n} expirados",
  "an2.trend": "Tendência",
  "an2.mViews": "Visualizações",
  "an2.mRedemptions": "Resgates",
  "an2.mShares": "Compartilhamentos",
  "an2.mFollowers": "Seguidores",
  "an2.noTrendData": "Nada aqui ainda para este.",
  "an2.followersChip": "{n} seguidores",
  "an2.dealTable": "Como cada oferta está se saindo",
  "an2.colDeal": "Oferta",
  "an2.colViews": "Visualizações",
  "an2.colGrabs": "Pegos",
  "an2.colRedeemed": "Resgatados",
  "an2.colRate": "Taxa",
  "an2.colShares": "Compartilhamentos",
  "an2.tableNote": "A taxa é o número de códigos resgatados em relação aos códigos pegados. Uma taxa alta significa que a oferta realmente converte — repita ou impulsione isso.",
  "an2.tipNearExpiryOne": "Uma oferta expira em 48 horas — renove ou ajuste o preço antes que expire",
  "an2.tableNoteFree": "Pro adiciona resgates, taxa de resgate e compartilhamentos para cada oferta nesta tabela.",
  "af.rowActions": "“Faça isso a seguir” — as correções que valem a pena, a partir dos seus próprios números",
  "af.onePick": "1 de 3",
  "af.rowDealTable": "Uma tabela: cada oferta com visualizações e capturas",
  "af.rowCompetition": "Concorrentes próximos e seus descontos, lado a lado",
  "pd2.moreOptions": "Mais opções",
  "pd2.moreHint": "Essas ficam como você deixou da última vez, então a maioria das ofertas precisa apenas de uma foto, um título e um preço.",
  "pd2.codesOn": "códigos ativados",
  "pd2.featuredOn": "em destaque",
  "pd2.endToday": "Hoje",
  "pd2.end3": "3 dias",
  "pd2.end7": "7 dias",
  "pd2.end14": "14 dias",
  "pd2.endPick": "Escolha uma data",
  "pd2.endsAt": "Termina {date} às {time} ({gmt})",
  "pd2.exactTime": "Hora exata de término",
  "pd2.addSpot": "Marcar um local diferente",
  "pd2.descHint": "Os compradores decidem a partir disso. {n} caracteres a mais necessários.",
  "pd2.descOk": "Os compradores decidem a partir deste — bom comprimento.",
  "pd2.writeForMe": "Escreva para mim",
  "pd2.undoDraft": "Desfazer",
  "pd2.draftFailed": "Não foi possível escrever um rascunho agora",
  "pd2.photoFirst": "Adicione uma foto primeiro e o rascunho descreverá o que realmente está nele.",
  "pd2.draftNoPhoto": "Escrito apenas pelo título — adicione uma foto para um rascunho mais claro.",
  "pc.yourPlan": "plano {plan}",
  "pc.freeForever": "Grátis, pelo tempo que você quiser.",
  "pc.lifetime": "Seu para a vida — sem renovação.",
  "pc.renews": "Renova {date}",
  "pc.autoRenewsOn": "Renova automaticamente em {date}",
  "pc.autoRenewOff": "Renovação automática desativada — o plano termina em {date}",
  "pc.cancelAutoRenew": "Cancelar renovação automática",
  "pc.resumeAutoRenew": "Reativar renovação automática",
  "pc.updateCard": "Atualizar cartão",
  "pc.renewNow": "Renovar agora",
  "pc.graceMsg": "Renove agora — seu plano expirou; os benefícios terminam em {n} dias.",
  "pc.billingFail": "Não foi possível abrir o portal de faturamento. Tente novamente.",
  "pc.renewOffToast": "Renovação automática desativada — seu plano continua até a data de término",
  "pc.renewOnToast": "Renovação automática reativada",
  "pc.renewFail": "Não foi possível atualizar a renovação automática. Tente novamente.",
  "pc.buyDeals": "Comprar ofertas extras",
  "bh.title": "Histórico de faturamento",
  "bh.subtitle": "Cada cobrança, com um código de recibo que você pode citar para verificar uma compra.",
  "bh.loading": "Carregando seus recibos…",
  "bh.empty": "Nenhum pagamento ainda.",
  "bh.invoice": "Fatura",
  "bh.paid": "pago",
  "bh.pending": "não concluído",
  "bh.refunded": "reembolsado",
  "pc.upgrade": "Atualizar",
  "pc.nOfMThisMonth": "{n} de {m} ofertas postadas este mês",
  "pc.unlimitedThisMonth": "Ofertas ilimitadas este mês",
  "pc.nLeft": "{n} restantes",
  "pc.noneLeft": "Nenhuma restante este mês",
  "pc.resets": "Sua cota reinicia {date}",
  "pc.creditsHeld": "Ofertas extras retidas",
  "pc.nCreditsHeld": "{n} ofertas extras retidas",
  "pc.locations": "Locais fixados",
  "pc.nBought": "{n} comprados",
  "pc.maxDays": "Dias que uma oferta pode durar",
  "pc.creditNote": "Ofertas extras são usadas apenas quando sua cota mensal acaba, e nunca expiram.",
  "tu.title": "Precisa de mais ofertas este mês?",
  "tu.sub": "Ofertas extras nunca expiram e são usadas apenas quando sua cota mensal acaba.",
  "tu.youHold": "Você tem {n} agora.",
  "tu.each": "{price} cada",
  "tu.perMonth": "/ 30 dias",
  "tu.buy": "Comprar",
  "tu.locationsTitle": "Locais extras no mapa",
  "pc.rolledOver": "Transferido do mês passado",
  "pc.rollsOverNote": "Ofertas não utilizadas são transferidas para o próximo mês, até {cap}.",
  "pc.noRollover": "Reinicializações gratuitas no dia 1 — planos pagos transferem ofertas não utilizadas.",
  "pc.boughtNote": "Comprado ou presenteado. Nunca expiram, mesmo no plano Gratuito.",
  "pc.maxDaysShort": "Uma oferta pode durar até {n} dias",
  "prc.f1": "4 ofertas por mês, reinicia no dia 1, até 14 dias cada",
  "prc.p1": "30 ofertas por mês — as não utilizadas acumulam, até 30 dias cada",
  "prc.b1": "150 ofertas por mês — as não utilizadas acumulam, até 60 dias cada",
  "prc.b2": "25 locais fixos, e você pode comprar mais",
  "pd2.titleSuggested": "Título mais atraente:",
  "pd2.useTitle": "Usar",
  "pd2.dismissTitle": "Manter o meu",
  "pd2.undoTitleChange": "Desfazer título",
  "pw.placeholder8": "Senha (pelo menos 8 caracteres)",
  "pw.placeholder12": "Senha (pelo menos 12 caracteres)",
  "prc.rollFree": "Renova no dia 1. Grátis não acumula ofertas não usadas.",
  "prc.rollPro": "Ofertas não usadas acumulam por um mês, até 30 — então um mês tranquilo pode deixar você com 60 para postar no próximo mês.",
  "prc.rollPlus": "Ofertas não usadas acumulam por um mês, até 150 — então um mês tranquilo pode deixar você com 300 para postar no próximo mês.",
  "prc.rollAddon": "Ofertas extras compradas como complementos nunca expiram.",
  "prc.rolledIn": "{n} acumuladas do mês passado",
  "acc.emailFreqIntro": "Com que frequência devemos te enviar e-mails sobre ofertas e promoções?",
  "acc.freq_instant": "Assim que acontece",
  "acc.freq_instant_note": "Um e-mail por oferta, ainda limitado a um por dia para não te sobrecarregar.",
  "acc.freq_daily": "Uma vez por dia",
  "acc.freq_daily_note": "Tudo do dia reunido em um e-mail. Recomendado.",
  "acc.freq_weekly": "Uma vez por semana",
  "acc.freq_weekly_note": "Um resumo por semana, nada no meio.",
  "acc.freq_off": "Sem e-mail de marketing",
  "acc.freq_off_note": "Nada promocional. Você ainda verá tudo no app.",
  "acc.emailFreqSaved": "Frequência de e-mail salva",
  "acc.emailCapNote": "Independentemente da sua escolha, nunca enviamos mais de um e-mail de marketing por dia ou três por semana.",
  "an3.withinRadius": "Concorrentes a uma distância de",
  "an3.anywhere": "Em qualquer lugar",
  "an3.radiusSummary": "{n} lojas {cat} com ofertas ativas a até {km} km do seu ponto.",
  "an3.radiusSummaryAny": "{n} lojas {cat} com ofertas ativas, as mais próximas primeiro.",
  "an3.noneInRadius": "Nenhuma outra loja {cat} está com uma oferta a até {km} km de você — esse espaço é seu.",
  "an3.noneAnywhere": "Nenhuma outra loja {cat} tem uma oferta ativa agora — esse espaço é seu.",
  "an3.radiusLocked": "Concorrentes próximos por distância é um recurso do Pro.",
  "an3.radiusNoPin": "Marque sua loja no mapa e podemos medir as lojas ao seu redor.",
  "an3.pinMyShop": "Marcar minha loja",
  "pw.acceptWeak": "Eu entendo que esta senha é fraca e quero usá-la mesmo assim",
  "pw.suggest": "Sugira uma senha para mim",
  "pw.memorable": "Fácil de lembrar",
  "pw.random": "Aleatória",
  "pw.words": "Palavras:",
  "pw.reroll": "Nova sugestão",
  "pw.copy": "Copiar",
  "pw.suggestNote": "Use-a e guarde-a num lugar seguro. Ela já cumpre nossas regras de segurança.",
  "auth.staffPortal": "Portal da equipe",
  "auth.staffSignIn": "Acesso da equipe",
  "auth.staffPortalNote": "Entre com sua conta de administrador.",
  "pw.floorNote": "Toda senha precisa ter pelo menos 8 caracteres, uma letra maiúscula e um símbolo.",
  "tu.credits_5.label": "5 ofertas extras",
  "tu.credits_5.note": "Cinco ofertas extras além da sua cota mensal. Elas nunca expiram.",
  "tu.credits_20.label": "20 ofertas extras",
  "tu.credits_20.note": "Vinte ofertas extras a 75 centavos cada em vez de $1. Elas nunca expiram.",
  "tu.credits_50.label": "50 ofertas extras",
  "tu.credits_50.note": "Cinquenta ofertas extras a 60 centavos cada — a forma mais barata de postar muitas. Elas nunca expiram.",
  "tu.branch_1_30d.label": "1 localização extra",
  "tu.branch_1_30d.note": "Adicione mais uma localização por 30 dias. Compre novamente para mantê-la.",
  "tu.branch_5_30d.label": "5 localizações extras",
  "tu.branch_5_30d.note": "Adicione cinco localizações a mais por 30 dias. Compre novamente para mantê-las.",
  "acc.quietTitle": "Horas de silêncio",
  "acc.quietNote": "Nada promocional chega durante a noite — espera pela manhã.",
  "acc.quietFrom": "Silêncio de",
  "acc.quietTo": "até",
  "acc.quietYourTime": "seu horário local",
  "acc.quietSaved": "Horas de silêncio salvas",
  "pw.leaked": "Visto em {n} vazamentos de dados conhecidos — os atacantes tentam esses primeiro.",
  "auth.backToLogin": "Voltar para o login",
  "auth.demoLabel": "Demonstração:",
  "acc.nextEmailAt": "Próximo e-mail: {when}",
  "acc.nextEmailOff": "Não enviaremos nada promocional por e-mail.",
  "acc.nextEmailSoon": "a qualquer momento",
  "acc.nextEmailToday": "hoje após {time}",
  "acc.nextEmailTomorrow": "amanhã após {time}",
  "acc.nextEmailWaiting": "{n} aguardando para ser agrupado",
  "an3.myCategory": "minha categoria",
  "lg.asIsTitle": "Serviço fornecido como está",
  "lg.asIsBody": "LytePress é uma plataforma em evolução, e embora nos esforcemos para fornecer uma experiência confiável e contínua, erros ou interrupções ocasionais podem ocorrer. Ao usar o LytePress, você reconhece que o faz por sua própria conta e risco. Não podemos garantir um serviço ininterrupto ou aceitar responsabilidade por perdas decorrentes do uso da plataforma. Se você encontrar erros ou problemas, pedimos gentilmente que nos avise para que possamos resolvê-los o mais rápido possível. Agradecemos sua compreensão e apoio enquanto continuamos a melhorar o LytePress.",
  "lg.asIsShort": "LytePress ainda está crescendo e mudando. É fornecido como está — você usa por sua conta e risco, e se algo quebrar, por favor nos avise para que possamos consertar.",
  "lg.passwordRules": "Toda senha precisa ter pelo menos 8 caracteres, uma letra maiúscula e um símbolo, e não pode conter seu próprio nome, nome da loja ou e-mail. Contas de loja e admin precisam de 12 caracteres. Verificamos novas senhas em listas públicas de senhas vazadas: uma conta de loja ou admin não pode usar uma que apareça em uma vazamento, e um comprador que escolher uma senha fraca ou vazada deve confirmar que aceita o risco.",
  "lg.quotaTerms": "Os planos pagos incluem um número mensal de ofertas que você pode postar (uma cota), não uma garantia de visualizações, cliques ou vendas. Ofertas não utilizadas em um plano pago são acumuladas por apenas um mês, limitadas ao valor de um mês. Ofertas compradas como complementos não expiram. Uma cota é um teto de uso justo e podemos ajustar os tetos com aviso.",
  "lg.aiHelp": "Cópia de oferta assistida por IA",
  "lg.aiHelpBody": "Oferecemos uma ferramenta opcional que redige um título e descrição de oferta a partir dos detalhes e foto que você fornece. O rascunho é apenas uma sugestão: você escolhe se deseja usá-lo, pode editá-lo ou desfazê-lo, e você continua responsável por tudo que é publicado em sua oferta, incluindo precisão, reivindicações e conformidade legal. Seu prompt e a primeira foto são enviados ao nosso fornecedor de IA para produzir o rascunho. Limitamos quantos rascunhos cada loja pode solicitar por dia e podemos desligar a ferramenta a qualquer momento.",
  "lg.emailsWeSend": "E-mails que enviamos",
  "lg.emailsWeSendBody": "E-mails de conta, segurança, pagamento e moderação fazem parte do serviço e são sempre enviados. E-mail promocional — alertas de novas ofertas, resumos e promoções — é limitado a um e-mail por dia e três por semana por conta, e você escolhe com que frequência ouve de nós (à medida que acontece, diariamente, semanalmente ou não) além de horários silenciosos quando nada promocional é enviado. Cada e-mail promocional contém um link para cancelamento de inscrição, e enviamos no idioma que você usa no site onde temos essa redação.",
  "lg.quotasAndCredits": "5. Cotizações mensais e ofertas extras",
  "lg.quotasAndCreditsBody": "A cota mensal de ofertas de um plano é redefinida no dia 1. Em planos pagos, ofertas não utilizadas são acumuladas por apenas um mês, limitadas ao valor de um mês, e não têm valor em dinheiro — uma cota não utilizada não é reembolsável e não pode ser transferida entre contas. Ofertas ou locais extras comprados como complementos não são reembolsáveis uma vez que qualquer parte tenha sido utilizada; se nenhuma parte foi utilizada, nos avise dentro de 14 dias e reembolsaremos.",
  "lg.collectLangEmail": "Também armazenamos o idioma em que você lê o site (para que nossos e-mails correspondam), sua frequência de e-mail e configurações de horários silenciosos, e um registro de quais e-mails promocionais enviamos para que possamos honrar os limites diários e semanais.",
  "lg.sharingAi": "Quando você usa a ferramenta opcional de redação de ofertas por IA, o texto que você inseriu e a primeira foto da oferta são enviados ao nosso fornecedor de IA para gerar o rascunho. Não enviamos seu nome, e-mail ou detalhes da conta, e não usamos suas ofertas para treinar modelos de ninguém.",
  "lg.breachCheckPrivacy": "Quando você define uma senha, verificamos contra listas públicas de senhas vazadas usando um método onde apenas os primeiros cinco caracteres de um hash unidirecional saem do nosso servidor — sua senha e o hash completo nunca saem. Se esse serviço não estiver disponível, simplesmente pulamos a verificação.",
  "lg.privacyEmailChoices": "Você controla o e-mail promocional em Minha Conta: escolha à medida que acontece, diariamente, semanalmente ou nenhum, defina horários silenciosos em seu próprio fuso horário, ou use o link de cancelamento de inscrição em qualquer e-mail promocional. E-mails de conta, segurança e pagamento não podem ser desligados enquanto sua conta estiver aberta.",
  "acc.browseDealsArrow": "Ver ofertas →",
  "acc.verifiedRedemptionsOnly": "Apenas resgates verificados na loja.",
  "acc.approxIn": "aprox. em {cur}",
  "an3.sameSpot": "Mesmo lugar",
  "an3.underTenth": "menos de 0,2 km",
  "an3.kmAway": "{km} km",
  "an3.nearestOf": "mais próximos de {n} locais",
  "an3.rivalsHidden": "{n} lojas rivais estão com ofertas aqui.",
  "an3.rivalsHiddenNote": "Pro e Elite mostram quem são, quão longe estão e quanto descontam.",
  "an3.liveCount": "{n} ao vivo",
  "bo.fitShorter": "Sua oferta termina em {days} dias, então isso dura {days} em vez de {full} — preço ajustado.",
  "bo.fitTooShort": "Esta oferta termina em menos de um dia. Renove ou estenda primeiro e o período completo é seu.",
  "an3.locationsCount": "{n} locais",
  "an3.locationN": "Local {n}",
  "an3.legendYou": "Você",
  "an3.legendRival": "Rival · média % de desconto",
  "an3.compareRival": "Comparar com minhas ofertas",
  "auth.agreeCheckbox": "Li e concordo com o",
  "lg.setOutBelow": "detalhes nas seções de cobrança abaixo",
  "acc.rivalAlertsTitle": "Me avise quando um concorrente oferecer um desconto maior",
  "acc.rivalAlertsNote": "Um aviso por semana, no máximo, quando uma loja a até 10 km na sua categoria postar um desconto pelo menos 10 pontos maior que sua média atual. Apenas Pro e Elite.",
  "acc.rivalAlertsOn": "Alertas de concorrentes ativados",
  "acc.rivalAlertsOff": "Alertas de concorrentes desativados",
  "st.asWeExpandThroughout": "À medida que crescemos em novas cidades e mercados, nosso objetivo é nos tornar o destino mais confiável para descobrir ofertas locais, promoções, experiências e oportunidades.",
  "st.valSustainable": "Incentivando o consumo sustentável em todos os mercados que atendemos.",
  "st.lytepressIsAGrowing": "LytePress é uma comunidade em crescimento que conecta pessoas a negócios locais, recompensa gastos inteligentes, apoia o empreendedorismo e incentiva o consumo sustentável.",
  "lg.contact2": "8. Contato",
  "lg.whoWeAre": "1. Quem somos",
  "lg.informationWeCollect": "2. Informações que coletamos",
  "lg.howWeUseIt": "3. Como usamos",
  "lg.location": "4. Localização",
  "lg.sharing": "5. Compartilhamento",
  "lg.security": "6. Segurança",
  "lg.yourChoices": "7. Suas escolhas",
  "lg.whoWeAreBody": "LytePress é o nome legal da entidade que opera esta plataforma, registrada em Trinidad e Tobago, e é a controladora de dados das informações descritas aqui. Servimos empresas e compradores em todo o mundo, então suas informações podem ser processadas em outros países pelos provedores listados em Compartilhamento. Dúvidas sobre seus dados: support@lytepress.com.",
  "lg.lawDisputesBody": "LytePress é o nome legal da entidade que opera esta plataforma e está registrada em Trinidad e Tobago, enquanto o serviço em si está disponível para empresas e compradores em todo o mundo — onde estamos registrados não limita onde operamos. Estes termos são regidos pelas leis de Trinidad e Tobago, e seus tribunais têm jurisdição sobre qualquer disputa. Isso não afeta nenhum direito que você tenha sob a lei do consumidor do país em que vive, e não limita os países que a LytePress atende. Fale conosco primeiro em support@lytepress.com — quase tudo é resolvido mais rápido assim.",
  "lg.plainSummary": "LytePress (\"nós\", \"nos\") permite que empresas publiquem suas ofertas e que compradores encontrem as promoções ao seu redor, onde quer que negociem. Essas páginas são escritas em linguagem simples de propósito, e se algo aqui não estiver claro, você pode enviar um e-mail para support@lytepress.com e uma pessoa explicará. Ao usar a LytePress, você concorda com os pontos abaixo.",
  "qa.firstDealPending": "Primeiro negócio — em revisão",
  "qa.firstDealPendingMsg": "Damos uma olhada rápida no primeiro negócio de uma nova loja antes de aparecer no mapa. Geralmente fica ativo em algumas horas, e todos os negócios depois desse são publicados imediatamente.",
  "rpt.notHonoured": "Negócio não foi honrado",
  "rpt.notHonouredSent": "Relatório enviado",
  "rpt.notHonouredThanks": "Obrigado por nos avisar",
  "rpt.notHonouredNote": "Isso vai direto para nossa equipe de moderação e nós seguimos com a loja.",
  "rpt.notHonouredHelp": "Entrou e a loja recusou esse negócio? Um toque nos avisa — sem formulário para preencher.",
  "ver.title": "Confirme seu e-mail para publicar ofertas",
  "ver.note": "Enviamos um link e um código de 6 dígitos para {email}. As ofertas que você postar ficam aguardando até você confirmar — elas vão ao ar assim que você fizer isso.",
  "ver.codePlaceholder": "000000",
  "ver.confirmCode": "Confirmar",
  "ver.resend": "Enviar novamente",
  "ver.sent": "E-mail a caminho",
  "ver.sentNote": "Verifique {email} — o link e o código funcionam.",
  "ver.couldNotSend": "Não foi possível enviar esse e-mail",
  "ver.badCode": "Esse código não funcionou",
  "ver.done": "E-mail confirmado",
  "ver.doneNote": "Tudo pronto — qualquer coisa que você tinha aguardando vai ao ar agora.",
  "ver.checking": "Confirmando seu e-mail...",
  "ver.badLink": "Esse link não funcionou",
  "ver.badLinkNote": "Pode ter expirado ou já ter sido usado.",
  "ver.useCodeInstead": "Digite o código de 6 dígitos do e-mail no banner do seu painel em vez disso.",
  "ver.noToken": "Este link está sem seu código.",
  "ver.goToAccount": "Ir para minha conta",
  "qa.emailPending": "Confirme seu e-mail primeiro",
  "qa.emailPendingMsg": "Sua oferta está salva e aguardando. Toque no link no e-mail que enviamos para você — ou digite o código de 6 dígitos no banner do seu painel — e ela vai ao ar imediatamente.",
  "ver.enterCodeHere": "Digite o código de 6 dígitos do e-mail aqui",
  "ver.manualTitle": "Confirme seu e-mail",
  "ver.manualNote": "Abra o e-mail que enviamos e digite o código de 6 dígitos abaixo. Não é necessário estar logado.",
  "ver.needANewOne": "Perdeu o e-mail ou o código expirou?",
  "ver.emailPlaceholder": "O e-mail que você usou para se inscrever",
  "ver.sendNewEmail": "Enviar um novo e-mail",
  "ver.emailSentShort": "E-mail enviado",
  "vf.unlocks": "Até você ser verificado, você pode publicar 2 ofertas ao mesmo tempo de um local, e a colocação paga permanece fechada. A verificação libera todas as três.",
  "qa.liveCapTitle": "Esse é o seu limite de ofertas ao vivo",
  "sr.passNeedsVerification": "Os Passes Boost são liberados assim que sua empresa for verificada.",
  "ver.domainTip": "Dica: confirmar um endereço no seu próprio domínio de negócios (não Gmail ou Hotmail) remove imediatamente os limites de ofertas ao vivo e localização.",
  "vf.domainTier": "Email do domínio confirmado",
  "vf.domainTierNote": "Você confirmou um código enviado para {domain}, um endereço no seu próprio domínio de negócios, então seus limites de negociação já foram liberados. A colocação paga ainda aguarda seus documentos.",
  "br.pinFarFromListing": "{branch} está fixado a cerca de {distance} km da lista do Google que encontramos sob seu nome — {listing}, {address}. Se o pin estiver errado, os compradores que tocarem em Direções serão enviados para um lugar que você não está. Arraste-o até sua porta e salve.",
  "br.thisPin": "Este pin",
  "fx.title": "Mover este pin?",
  "fx.summary": "{business} tem {branch} fixado a cerca de {distance} km da listagem do Google que encontramos sob seu nome — {listing}{address}.",
  "fx.legend": "Vermelho é onde seu pin está agora. Verde é a listagem. Confirmar move o pin salvo e o mesmo pin nas suas ofertas ativas. Se seu pin estiver correto e a listagem pertencer a outra pessoa, basta fechar esta página — nada muda.",
  "fx.confirm": "Sim, mova meu pin aqui",
  "fx.now": "Agora",
  "fx.listing": "Listagem",
  "fx.moved": "Pin movido",
  "fx.movedNote": "{branch} agora está em {address}. Suas ofertas ativas também foram atualizadas, então Direções envia os compradores para o lugar certo a partir de agora.",
  "fx.yourPin": "Seu pin",
  "fx.yourListing": "sua listagem do Google",
  "fx.aLocation": "uma localização",
  "fx.expired": "Esse link expirou",
  "fx.expiredNote": "Links de um toque duram 14 dias. Você ainda pode mover o pin você mesmo a partir da Minha Conta.",
  "fx.cantUse": "Não podemos usar esse link",
  "fx.checking": "Verificando esse link…",
  "fx.noCode": "Esse link está faltando seu código. Abra o e-mail novamente.",
  "fx.invalid": "Esse link não é mais válido.",
  "fx.failed": "Não foi possível mover esse pin.",
  "fx.openAccount": "Abrir Minha Conta",
  "fx.byHand": "para mover qualquer pin manualmente.",
  "pv.verifiedOn": "Preço verificado {date}",
  "pv.checkFirst": "Verifique o preço antes de ir",
  "pv.changed": "Os compradores dizem que este preço mudou",
  "pv.tooltip": "A última vez que alguém confirmou este preço.",
  "pv.countOne": "1 comprador confirmou",
  "pv.countMany": "{n} compradores confirmaram",
  "pv.shopperHelp": "Esteve aqui recentemente? Diga a todos se este preço ainda é válido.",
  "pv.ownerHelp": "Ainda é seu preço? Um toque revalida este desconto como verificado hoje.",
  "pv.signInHint": "Faça login como comprador para confirmar este preço.",
  "pv.stillRight": "Preço ainda está certo",
  "pv.priceChanged": "Preço mudou",
  "pv.youConfirmed": "Você confirmou este preço.",
  "pv.youFlagged": "Você nos avisou que este preço mudou.",
  "pv.thanksConfirmed": "Obrigado — preço verificado",
  "pv.thanksConfirmedMsg": "Todo comprador que vê este desconto agora sabe que o preço está atualizado.",
  "pv.thanksFlagged": "Obrigado pelo aviso",
  "pv.thanksFlaggedMsg": "Vamos pedir à loja para reafirmar o preço.",
  "pv.couldNotSave": "Não foi possível salvar isso",
  "pv.wasItRight": "O preço estava certo?",
  "pv.yesRight": "Sim, exatamente",
  "pv.noChanged": "Não, mudou",
  "footer.cities": "Cidades",
  "cities.seoTitle": "Ofertas por cidade",
  "cities.seoDesc": "Cada cidade com ofertas ativas no LytePress, além dos lugares que estamos abrindo em breve.",
  "cities.heading": "Ofertas por cidade",
  "cities.subline": "Escolha sua cidade e veja o que está disponível agora. Novas cidades aparecem aqui assim que as lojas começam a postar.",
  "cities.openingSoon": "Abrindo em breve",
  "city.seoTitle": "Ofertas em {city}, {country}",
  "city.seoDescEmpty": "LytePress está abrindo em {city}, {country}. Conhece uma loja que deveria estar aqui? Convide-a.",
  "city.heading": "Ofertas em {city}",
  "city.sublineEmpty": "Estamos abrindo em {city}, {country}. Nenhuma oferta aqui ainda.",
  "city.liveDeals": "{n} ofertas ativas",
  "city.shops": "{n} lojas",
  "city.onTheMap": "Veja no mapa",
  "city.allCities": "Todas as cidades",
  "city.noPage": "Ainda não há página de ofertas para essa cidade.",
  "city.emptyTitle": "Nada ativo em {city} ainda",
  "city.emptyBody": "Abrimos uma cidade no momento em que uma loja posta lá. Se você conhece algum lugar em {city} que vale um espaço no mapa, nos avise — leva um minuto e é grátis.",
  "city.browseEverywhere": "Navegue por ofertas em todos os lugares",
  "city.aboutTitle": "Sobre as ofertas em {city}",
  "city.aboutBody": "O LytePress lista o que as lojas locais em {city}, {country} estão com desconto agora — principalmente {cats}. Cada oferta mostra o preço, qual era, por quanto tempo dura e exatamente onde ir.",
  "city.aboutTrust": "Os preços têm a data em que foram confirmados pela última vez, e os compradores que estiveram lá podem informar aos outros se um preço ainda é válido. Nada aqui é um palpite.",
  "city.everyCategory": "todas as categorias",
  "city.nearbyTitle": "Outras cidades",
  "city.otherLanguages": "Leia isso em",
  "city.seoDesc": "{deals} de {shops} em {city}, {country}. Preços confirmados por compradores, atualizados todos os dias.",
  "city.subline": "{deals} de {shops} em {city}, {country} — com preços confirmados pelos compradores.",
  "city.liveDealOne": "1 oferta ativa",
  "city.shopOne": "1 loja",
  "loc.following": "Seguindo sua localização",
  "loc.followingLive": "Seguindo você enquanto se move",
  "loc.notFollowing": "Localização fixada aqui",
  "loc.turnOff": "desligar",
  "loc.turnOn": "me siga novamente",
  "loc.goLive": "seguir enquanto me movimento",
  "loc.stopLive": "parar de seguir ao vivo",
  "loc.nearCity": "Você está perto de {city}",
  "loc.seeThoseDeals": "Veja essas ofertas",
  "pd.quietHours": "Oferta de horas tranquilas",
  "pd.quietHoursHint": "Um desconto fixo que se repete — como das 15h às 17h nos dias de semana, para preencher a calmaria.",
  "pd.quietFrom": "De",
  "pd.quietTo": "Até",
  "pd.quietNote": "Os compradores ainda veem a oferta fora desses horários — ela mostra quando começa, e os códigos só funcionam dentro da janela.",
  "pd.mon": "Seg",
  "pd.tue": "Ter",
  "pd.wed": "Qua",
  "pd.thu": "Qui",
  "pd.fri": "Sex",
  "pd.sat": "Sáb",
  "pd.sun": "Dom",
  "time.am": "am",
  "time.pm": "pm",
  "qh.onUntil": "Até {time}",
  "qh.starts": "Começa {time}",
  "qh.runs": "Dura {days}, de {from} a {to}",
  "qh.weekdays": "dias de semana",
  "qh.weekends": "fins de semana",
  "qh.everyDay": "todos os dias",
  "pitch.print": "Imprimir ambas as folhas",
  "pitch.printHint": "Duas páginas: esta cidade, depois o que é a LytePress. Imprima ou salve como PDF.",
  "pitch.cityHeading": "{city} já está no mapa.",
  "pitch.citySub": "Isso é o que os compradores em {city}, {country} veem quando abrem a LytePress e procuram algo que valha a pena sair de casa.",
  "pitch.statDeals": "Ofertas ativas",
  "pitch.statShops": "Lojas listadas",
  "pitch.statTop": "Mais listadas",
  "pitch.mapTitle": "O mapa hoje",
  "pitch.yourSpot": "Seu espaço",
  "pitch.noMapKey": "Mapa indisponível",
  "pitch.alreadyOn": "Já na LytePress aqui",
  "pitch.claimTitle": "Há uma lacuna em {city}.",
  "pitch.claimBody": "Escaneie para garantir seu espaço. A listagem é gratuita, leva cerca de dois minutos, e sua primeira oferta pode estar ativa hoje.",
  "pitch.qrCityPage": "Veja as ofertas de {city}",
  "pitch.qrClaim": "Garanta seu espaço",
  "pitch.aboutHeading": "O que é a LytePress.",
  "pitch.aboutLine": "Um mapa de ofertas reais de lojas reais. Os compradores o abrem para ver o que está com desconto perto deles agora — e cada preço carrega a data em que alguém esteve por trás dele.",
  "pitch.mapCaption": "Cada pino é uma loja com uma oferta ativa.",
  "pitch.forShoppers": "Para compradores",
  "pitch.shopper1": "Veja o que está descontado a uma curta distância, agora, com direções para a porta.",
  "pitch.shopper2": "Cada preço mostra quando foi confirmado pela última vez — pela loja ou por um comprador que esteve lá.",
  "pitch.shopper3": "Alimentos perto do vencimento e estoque com data curta em um só lugar, para que boa comida seja consumida em vez de descartada.",
  "pitch.forShops": "Para lojas",
  "pitch.shop1": "A listagem é gratuita. Você publica uma oferta, ela aparece no mapa e na página da sua cidade.",
  "pitch.shop2": "Venda estoque que está perto da data em vez de descartá-lo.",
  "pitch.shop3": "Preencha suas horas tranquilas com um desconto fixo que funciona apenas na janela que você escolher.",
  "pitch.howTitle": "Como funciona",
  "pitch.how1": "Cadastre-se como loja e coloque um pino onde você realmente está.",
  "pitch.how2": "Publique sua oferta — uma foto, o preço e por quanto tempo dura.",
  "pitch.how3": "Compradores nas proximidades a veem, entram e mostram um código que você verifica no balcão.",
  "pitch.startTitle": "Comece com uma oferta.",
  "pitch.startBody": "Escaneie isso, inscreva-se e coloque uma oferta no mapa. Se ninguém aparecer, você perdeu apenas dois minutos.",
  "pitch.qrStart": "Inscreva sua loja",
  "pitch.exampleTitle": "Como é uma semana em {city}",
  "pitch.exampleTag": "Exemplo",
  "pitch.demoNote": "Os pins e listagens acima são exemplos — {city} está aberta e esperando suas primeiras lojas.",
  "pitch.mapCaptionDemo": "Pins de exemplo — assim é como uma cidade fica quando as lojas começam a postar.",
  "pitch.cityHeadingDemo": "{city} é o próximo no mapa.",
  "pitch.citySubDemo": "LytePress está chegando em {city}, {country}. Isso é o que os compradores aqui verão — e como sua própria lista ficaria.",
  "pitch.sellFreeN": "Grátis",
  "pitch.sellFree": "Para listar suas ofertas",
  "pitch.sellFastN": "2 min",
  "pitch.sellFast": "Para cadastrar sua loja",
  "pitch.sellLiveN": "Hoje",
  "pitch.sellLive": "Sua primeira oferta vai ao ar",
  "pd.shortDatedHint": "Para produtos perto da data de validade - alimentos, bebidas, suplementos, medicamentos, cosméticos, óleo de motor, baterias, sementes, tinta. Os compradores veem um selo de Data Curta; ser transparente vende mais rápido e reduz o desperdício.",
  "pc.giftedNote": "Presente nosso. Os datados são usados primeiro.",
  "pc.giftedHeld": "Extras presentes",
  "pc.giftedUseBy": "Use {n} antes de {date}",
  "lo.title": "Um agradecimento da LytePress",
  "lo.credits": "{n} ofertas extras já estão na sua conta.",
  "lo.neverExpires": "Elas nunca expiram.",
  "lo.useBy": "Use-as antes de {date}.",
  "lo.codeLine": "E {off} de desconto em {what} com seu código.",
  "lo.codeValid": "Seu código, uso único, até {date}.",
  "lo.useIt": "Use-o",
  "lo.seePlans": "Ver planos",
  "lo.copy": "Copiar código",
  "lo.pkgPro": "Pro mensal",
  "lo.pkgProYear": "Pro anual",
  "lo.pkgElite": "Elite mensal",
  "lo.pkgEliteYear": "Elite anual",
  "lo.pendingTitle": "Um pacote escolhido para a sua loja",
  "lo.pendingWhat": "Inclui {what}",
  "lo.pay": "Pagar {price}",
  "lo.paying": "Abrindo o pagamento…",
  "lo.invoiceMonthly": "{price} — cobrado mensalmente, enviaremos a fatura.",
  "lo.payFailed": "Não foi possível abrir o pagamento. Tente novamente.",
  "lo.pkgPlan": "seu plano",
  "lo.titleSoon": "Apenas {n} dias restantes para usar isso",
  "vf.body": "Envie-nos seus documentos comerciais e adicionaremos um selo azul de verificado ao seu perfil. Os compradores confiam mais nas lojas verificadas — e isso desbloqueia todas as categorias.",
  "vf.regPlaceholder": "Número de registro (opcional)",
  "qa.needs_verification": "Ofertas de “{category}” só podem ser postadas por um negócio verificado. Verifique-se na Minha Conta — geralmente em um dia.",
  "trust.verifiedBody": "Aprovado pela nossa equipe.",
  "trust.independentBody": "Ainda não aprovado — mas muitos ótimos vendedores locais começam aqui. As ofertas deles ainda são verificadas quanto à qualidade.",
  "browse.nothingWithin": "Nada a menos de {radius} agora",
  "browse.nothingWithinMsg": "Nenhuma oferta ativa tem um ponto a menos de {radius} de você. Em vez de encher a página com lojas que você não consegue alcançar, esta é a resposta honesta — e duas formas de ampliar a busca.",
  "browse.showFurther": "Ver {n} ofertas mais distantes",
  "browse.hideFurther": "Ocultar ofertas mais distantes",
  "browse.furtherNote": "Estão além de {radius} de você, as mais próximas primeiro.",
  "browse.browseCountry": "Ver o país inteiro",
  "mt.title": "Voltamos já",
  "mt.body": "O LytePress está em uma atualização programada. Sua conta não é afetada: ofertas, créditos e códigos continuam exatamente onde você deixou.",
  "mt.backIn": "Voltamos em",
  "mt.backAt": "Retorno previsto às {time}",
  "mt.soon": "Voltamos a qualquer momento.",
  "mt.staff": "Acesso da equipe",
  "mt.readonly": "Manutenção programada: você pode navegar, mas publicar e pagar estão pausados.",
  "mt.notice": "Manutenção programada {when} — o site pode ficar indisponível por pouco tempo.",
  "mt.adminOn": "O modo manutenção está ATIVO — todos, exceto administradores, estão bloqueados.",
  "prc.usdNote": "Cobrado em dólares americanos. Se o seu cartão for em outra moeda, o banco converte pela taxa dele, então a fatura pode mostrar um valor um pouco diferente.",
  "prc.feeNote": "Seu banco pode adicionar taxas de conversão de moeda ou de transação.",
  "lg.availabilityTitle": "Disponibilidade do serviço e manutenção programada",
  "lg.availabilityBody": "O LytePress é atualizado com frequência. Atualizações de software e manutenção são feitas em intervalos, e o acesso ao site, ao app ou ao seu painel pode ficar temporariamente indisponível enquanto esse trabalho acontece.\n\nQuando o trabalho é planejado e pode interromper o serviço, procuramos avisar no app com antecedência e agendá-lo para horários de menor movimento. Períodos curtos de indisponibilidade, planejados ou não, fazem parte do funcionamento normal de um serviço online e, por si só, não dão direito a reembolso. Se um Boost ou destaque pago não rodou por causa de uma queda do nosso lado, creditamos ou reembolsamos esse destaque — escreva para support@lytepress.com e resolvemos.",
  "lg.forceMajeureTitle": "Força maior",
  "lg.forceMajeureBody": "Nem você nem o LytePress são responsáveis por não cumprir uma obrigação destes termos quando a causa está fora do controle razoável. Isso inclui tempestades, furacões, enchentes, terremotos, incêndio, epidemia ou pandemia, guerra, agitação civil, greves, atos ou ordens de governo ou regulador, falha de energia elétrica ou de internet, e a falha ou suspensão de um fornecedor terceiro do qual dependemos, como hospedagem, pagamentos, mapas ou e-mail.\n\nEnquanto esse evento durar, as obrigações afetadas ficam pausadas em vez de descumpridas, e restabeleceremos o serviço normal assim que for razoavelmente possível. Se um evento desse tipo deixar o serviço fora do ar por mais de 30 dias seguidos, qualquer uma das partes pode encerrar uma assinatura paga e reembolsaremos a parte não utilizada do período.",
};

export default pt;
